<template>
  <div>
    <!-- 顶部信息展示 -->
    <div class="headInform">
      <!-- 项目信息 -->
      <div class="item_information">
        <div class="imgboxTop">
          <div class="imageBox">
            <img v-if="levelItem.companyLogo" :src="levelItem.companyLogo" alt="" />
            <img v-else :src="require('@/assets/pro.png')" alt="" />
          </div>
          <div class="top">
            <div class="title">{{ levelItem.corporateName }}</div>
            <div class="ranking">[NO:{{ levelItem.uniqueId }}]</div>
          </div>
        </div>
        <div class="inform">
          <div
            class="demand"
            @mouseenter="isShow = true"
            @mouseleave="isShow = false"
            v-if="levelItem.coreRequirements"
          >
            核心要求：{{ levelItem.coreRequirements }}
            <div
              class="demand_box"
              v-show="isShow"
              @mouseenter="isShow = true"
              @mouseleave="isShow = false"
            >
              核心要求：{{ levelItem.coreRequirements }}
            </div>
          </div>
        </div>
      </div>
      <!-- 进度条 -->
      <div class="progress_box">
        <div class="progress">
          <el-steps :active="levelItem.projectScheduleInt" align-center>
            <el-step>
              <template slot="title">
                <div class="item">立项</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.projectApprovalTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item mapping">人才mapping</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.talentMappingTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">人才推荐</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.talentRecommendTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">面试邀约</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.interviewInvitationTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">offer谈判</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.offerNegotiationTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">offe接受</div>
              </template>

              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.offerAcceptTime }}
                </div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item">入职</div>
              </template>

              <template slot="description">
                <div class="time">{{ projectNewsTime.entryTime }}</div>
              </template>
            </el-step>
            <el-step>
              <template slot="title">
                <div class="item have_not_started">保证期结束</div>
              </template>
              <template slot="description">
                <div class="time">
                  {{ projectNewsTime.endGuaranteePeriodTime }}
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>
      </div>
      <div class="back_btn" @click="backPage">返回上级</div>
    </div>
    <!-- 搜索筛选 -->
    <div class="conditionSearch">
      <el-collapse v-model="activeName" @change="handleChange">
        <el-collapse-item name="1">
          <template slot="title">
            <div style="display: flex; justify-content: space-between">
              <div class="input_new">
                <el-input
                  placeholder="请输入关键词"
                  class="input-with-select"
                  clearable
                  v-model="queryInfo.keyword"
                  @change="cleanSearch"
                >
                  <el-button slot="append" icon="el-icon-search" @click="keywordSearch" />
                </el-input>
              </div>
            </div>
          </template>
          <!-- 顶部条件筛选 -->
          <div class="labelStyle">
            <el-form label-width="100px">
              <!-- <el-form-item label="项目状态：">
                <div class="buttonContent">
                  <el-checkbox-button
                    label="不限"
                    :value="noLimit"
                    @change="limitClick()"
                  ></el-checkbox-button>
                  <el-checkbox-group v-model="queryInfo.projectStatus" @change="noLimitClick()">
                    <el-checkbox-button
                      v-for="(el, i) in codeData"
                      :key="i + 'only'"
                      :label="el.slice(0, 2)"
                    >
                      {{ el }}
                    </el-checkbox-button>
                  </el-checkbox-group>
                </div>
              </el-form-item>
              <el-form-item label="优先级：">
                <radio-select
                  :key="2"
                  :code.sync="queryInfo.priority"
                  type-code="009"
                  @onChange="
                    search()
                    queryInfo.pageNum = 1
                    queryInfo.pageSize = 30
                  "
                />
              </el-form-item> -->
              <div class="experience">
                <div class="label">审核状态：</div>
                <div>
                  <el-radio-group v-model="queryInfo.reviewStatus" @change="searchStatus">
                    <el-radio-button label>不限</el-radio-button>
                    <el-radio-button
                      v-for="(item, index) in projectStatusList"
                      :key="index + item.codeName"
                      :label="item.codeId + ''"
                    >
                      {{ item.codeName }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
              </div>
              <div class="experience">
                <div class="label">人才进度：</div>
                <el-radio-group v-model="queryInfo.projectSchedule" @change="projectScheduleSearch">
                  <el-radio-button label="沟通列表">不限</el-radio-button>
                  <el-radio-button
                    v-for="(item, index) in projectScheduleList"
                    :key="index"
                    :label="item.label"
                    @click="clickProjectSchedule(item, index)"
                  >
                    {{ `${item.label}(${item.value})` }}
                  </el-radio-button>
                </el-radio-group>
              </div>
              <div class="spot">
                <div class="label">期望地点：</div>
                <CascaderArea
                  country=""
                  province=""
                  city=""
                  @searchArae="searchArae"
                ></CascaderArea>
              </div>
              <div class="experience">
                <div class="label">工作经验：</div>
                <div
                  class="experience_item"
                  :class="{
                    active: index == experienceIndex
                  }"
                  v-for="(item, index) in experienceList"
                  :key="index"
                  @click="clickExperience(item, index)"
                >
                  {{ item.value }}
                </div>
              </div>
              <div class="positionType">
                <div class="label">职位类型：</div>
                <div
                  :class="{
                    active: index == positionTypeIndex
                  }"
                  class="positionType_item"
                  v-for="(item, index) in positionTypeList"
                  :key="item.codeId"
                  @click="clickPositionTypeItem(item, index)"
                >
                  {{ item.codeName }}
                </div>
              </div>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- 表格 -->
    <div class="table">
      <!-- 数据排序 -->
      <div class="search" style="position: relative">
        <div class="upload_time">
          <div class="caretTime" @click="uploadTalent">人才进度</div>
          <div class="san">
            <i
              class="el-icon-caret-top"
              :class="[queryInfo.progressTalent == 'asc' ? 'isActiveTime1' : 'iconColor']"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[queryInfo.progressTalent == 'desc' ? 'isActiveTime1' : 'iconColor']"
            />
          </div>
        </div>
        <div class="upload_time">
          <div class="caretTime" @click="uploadCreate">新增时间</div>
          <div class="san">
            <i
              class="el-icon-caret-top"
              :class="[queryInfo.createTime == 'asc' ? 'isActiveTime1' : 'iconColor']"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[queryInfo.createTime == 'desc' ? 'isActiveTime1' : 'iconColor']"
            />
          </div>
        </div>
        <div class="upload_time">
          <div class="caretTime" @click="updateStatus">最近更新时间</div>
          <div class="san">
            <i
              class="el-icon-caret-top"
              :class="[queryInfo.updateTime == 'asc' ? 'isActiveTime1' : 'iconColor']"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[queryInfo.updateTime == 'desc' ? 'isActiveTime1' : 'iconColor']"
            />
          </div>
        </div>
        <div class="upload_time">
          <div class="caretTime" @click="auditingStatus">审核状态</div>
          <div class="san">
            <i
              class="el-icon-caret-top"
              :class="[queryInfo.reviewStatusSort == 'asc' ? 'isActiveTime1' : 'iconColor']"
            />
            <i
              class="el-icon-caret-bottom"
              :class="[queryInfo.reviewStatusSort == 'desc' ? 'isActiveTime1' : 'iconColor']"
            />
          </div>
        </div>
        <div style="margin-left: 60px">
          <el-checkbox v-model="checked1" @change="reviewStatusChange">
            待审核
            <span class="re">
              ({{ reviewPendingNum }})
              <span class="tag" v-if="reviewPendingNum != 0"></span>
            </span>
          </el-checkbox>
        </div>
        <div style="position: absolute; right: 20px; display: flex" v-if="false">
          <div
            class="add_candidate position_re"
            @mouseenter="showBtnListHandle"
            @mouseleave="hideBtnlistHandle"
          >
            ＋添加推荐人
            <ul
              class="position_ab"
              v-show="showBtnList"
              @mouseenter="showBtnListHandle"
              @mouseleave="hideBtnlistHandle"
            >
              <li>
                <up-load @personCode="uploadPersonCode" name="简历新增"></up-load>
              </li>
              <li class="pad_li" @click="addPersonBtnClick(1)">本地新增</li>
              <li class="pad_li" @click="addPersonBtnClick(2)">从人才库新增</li>
            </ul>
          </div>
          <div class="remove_candidate" @click="removeh">+ 移除推荐人</div>
        </div>
      </div>
      <!-- 表格数据 -->
      <div class="candidate_list">
        <div
          class="candidate_list_item"
          v-for="(item, index) in queryList"
          :key="index"
          :class="{
            active: item.isSelected
          }"
          @click="clickAddActive(item, index)"
        >
          <!-- 标识 -->
          <div class="identification">
            <img v-if="item.progress == '触达'" src="@/assets/images/Group 1142813959.png" alt="" />
            <img v-if="item.progress == '推荐'" src="@/assets/images/Group 2316.png" alt="" />
            <img v-if="item.progress == '面试'" src="@/assets/images/Group 2317.png" alt="" />
            <img v-if="item.progress == 'offer'" src="@/assets/images/Group 2318.png" alt="" />
            <img v-if="item.progress == '回款'" src="@/assets/images/Group 2319.png" alt="" />
            <img v-if="item.progress == '淘汰'" src="@/assets/images/Group 2320.png" alt="" />
          </div>

          <!-- 人物信息 -->
          <div class="left">
            <div class="image_box">
              <img class="img" :src="item.headPortraits" alt="" />
            </div>
            <div class="user_info">
              <div class="user_name">
                <div class="name">{{ item.name }}</div>
                <div class="sex">
                  <i v-if="item.sex == '男'" style="color: #4d70fa" class="el-icon-male"></i>
                  <i v-else-if="item.sex == '女'" style="color: #f56c6c" class="el-icon-female"></i>
                </div>
              </div>
              <!-- <div class="age">
                <span style="margin-right: 9px">{{ item.age }}</span>
                <span style="margin-right: 9px" v-if="item.workingYears"
                  >工作{{ item.workingYears }}年</span
                >
                <span style="margin-right: 9px" v-if="queryList[index].personEducational[0]">{{
                  item.personEducational[0].education
                }}</span>
                <span style="margin-right: 9px">{{ item.personProvince }}</span>
              </div> -->

              <div
                class="xueli source"
                v-if="
                  (item.personEducational[0] || []).schoolName ||
                  (item.personEducational[0] || []).major ||
                  (item.personEducational[0] || []).education
                "
              >
                <img
                  src="../../../assets/icons/community-line.png"
                  alt=""
                  style="margin-right: 4px"
                />
                <!-- <span>{{ item.personEducational[0].schoolName }}</span> -->
                <span>{{ (item.personEducational[0] || []).schoolName }}</span>
                <div
                  v-if="
                    (item.personEducational[0] || []).schoolName &&
                    (item.personEducational[0] || []).major
                  "
                >
                  -
                </div>
                <span>{{ (item.personEducational[0] || []).major }}</span>
                <div
                  v-if="
                    (item.personEducational[0] || []).major &&
                    (item.personEducational[0] || []).education
                  "
                >
                  -
                </div>
                <span>{{ (item.personEducational[0] || []).education }}</span>

                <!-- item.personEducational[0].schoolName   -->
                <!-- <span>{{
                  (item.personEducational || {}).schoolName
                }}</span>
                <div class="source_line"></div>
                <span>{{
                (item.personEducational || {}).major
                }}</span>
                <div class="source_line" v-if="item.personEducational[0].education"></div>
                <span>{{
                  (item.personEducational || {}).education
                }}</span>
                <span></span> -->
              </div>

              <div class="source">
                {{ item.expectedPosition }}
                <div class="source_line" v-if="item.expectedPosition && item.workingYears"></div>
                <div>{{ item.workingYears }}</div>
                <div class="source_line" v-if="item.expectedProvince || item.expectedCity"></div>
                {{ item.expectedProvince }}
                <span v-if="item.expectedProvince && item.expectedCity">-</span>
                {{ item.expectedCity }}
              </div>
            </div>
          </div>

          <!-- 进度 -->
          <div class="center">
            <div class="timeline_box" v-if="item.personExperience">
              <el-timeline :reverse="true">
                <el-timeline-item
                  v-for="(items, index) in item.personExperience"
                  :key="index + 10"
                  v-show="index < 3"
                >
                  <span style="color: #808080; margin-right: 5px" class="endTimeStyle">
                    {{ items.inductionTime }}
                    -
                    <span v-if="items.quitTime !== '1999'">{{ items.quitTime }}</span>
                    <span v-else style="color: #999999">至今</span></span
                  >
                  <span style="color: #1a1f33; margin-right: 5px" v-if="items.companyName">{{
                    items.companyName
                  }}</span>
                  <span style="color: #1a1f33; margin-right: 5px" v-if="items.position">{{
                    items.position
                  }}</span>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>

          <!-- 操作 -->
          <div class="right">
            <div class="right_options">
              <div class="compile" @click="openBiographical(item)" v-if="item.file">导出简历</div>
              <!-- 待审核 和 审核不通过  -->
              <el-button
                class="shenhe"
                v-if="item.reviewStatus == 0 || item.reviewStatus == 2"
                @click="toPersonAuting1(item)"
                >人选审核</el-button
              >
              <el-button
                class="newsets"
                v-if="item.reviewStatus == 0 || item.reviewStatus == 2"
                :disabled="item.reviewStatus == 0 || item.reviewStatus == 2"
                @click="clickNewest(item)"
                >更新进度</el-button
              >
              <!-- <div class="compile" @click="toPersonAuting(item)" v-if="item.reviewStatus == 1">
                人选报告
              </div> -->
              <div class="download" @click.stop="clickDownload(item)" v-show="item.file">
                <i class="el-icon-download"></i>
                下载简历
              </div>
              <div class="newest" v-if="item.reviewStatus == 1" @click="clickNewest(item)">
                更新进度
              </div>
              <!-- 审核通过 -->
              <el-button
                type="primary"
                icon="el-icon-edit"
                v-if="item.reviewStatus == 1"
                @click="clickToCompile(item)"
                >编辑报告</el-button
              >
              <el-button type="text" v-if="item.reviewStatus == 1" @click.stop="edit(item)"
                >查看详情</el-button
              >
              <!-- <div class="details" @click.stop="edit(item)">查看详情</div> -->
            </div>
            <!-- 审核状态 0 未审核 1 审核成功 2 审核失败 -->
            <div class="reviewReason" v-if="item.reviewStatus == 2">
              <img src="../../../assets/icons/error-warning-line.png" alt="" />
              <span>{{ item.rejectionReason }}</span>
            </div>
            <div class="created_time" v-if="item.updateTime">
              最近更新时间：{{ item.updateTime }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        :current-page="queryInfo.baseParam.pageNum"
        :page-sizes="[10, 30, 60]"
        :page-size="queryInfo.baseParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 进度列表弹窗 -->
    <div class="dialog_box">
      <el-dialog :visible.sync="dialogVisible" width="60%" @close="dialogClose">
        <div slot="title">
          <div class="title">
            <div class="title_name">{{ queryItem.name }}</div>
            <div class="add" @click="showAddScheduleDialog">+添加进度</div>
          </div>
        </div>
        <ul>
          <li v-for="item in addSchedule" :key="item.id">
            <div class="circles_box"></div>
            <div class="name_row">
              <div class="left">
                <div class="name mr-r-10">
                  {{ item.talentProgress }}
                </div>
                <div class="tag_box" :class="getTagBoxClass(item)">
                  {{ getTagTxt(item) }}
                  <!-- {{ item.isReach ? '已触达' : '未触达' -->
                </div>
              </div>
              <div class="right">
                <div style="margin-right: 16px">
                  {{ '操作人：' + item.updateName }}
                </div>
                <div>{{ item.updateTime }}</div>
              </div>
            </div>
            <div class="details_row">
              <!-- 触达 -->
              <div class="details_box" v-if="item.talentProgress === '触达'">
                <div class="info_item" v-if="!item.isReach">
                  <div class="item_title">来源：</div>
                  <div class="item_txt">
                    <div>
                      {{ getReachSourceTxt(item.source) }}
                      {{ item.source }}
                    </div>
                  </div>
                </div>
                <div class="info_item" v-if="!item.isReach">
                  <div class="item_title">简历：</div>
                  <div class="item_txt">
                    <div>
                      {{ item.isCurriculumVitae ? '有' : '无' }}
                    </div>
                  </div>
                </div>
                <div class="info_item" v-if="!item.isReach">
                  <div class="item_title">联系方式：</div>
                  <div class="item_txt">
                    <div>
                      {{ item.isContactInformation ? '有' : '无' }}
                    </div>
                  </div>
                </div>
                <div class="info_item" v-if="item.isReach">
                  <div class="item_title">触达进度：</div>
                  <div class="item_txt">
                    <div>{{ item.reachSchedule }}</div>
                  </div>
                </div>
                <div class="info_item" v-if="item.isReach">
                  <div class="item_title">触达结果：</div>
                  <div class="item_txt">
                    <div>
                      {{ getReachResultTxt(item.reachResult) }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- 推荐 -->
              <div v-else-if="item.talentProgress === '推荐'">
                <div class="details_box" v-if="item.isRecommended">
                  <div class="info_item">
                    <div class="item_title">推荐日期：</div>
                    <div class="item_txt">
                      <div>{{ item.recommendedTime }}</div>
                    </div>
                  </div>
                  <div class="info_item">
                    <div class="item_title">客户反馈：</div>
                    <div class="item_txt">
                      <div>
                        {{ item.isFeedback ? '已反馈' : '未反馈' }}
                      </div>
                    </div>
                  </div>
                  <div class="info_item" v-if="item.isFeedback">
                    <div class="item_title">是否面试：</div>
                    <div class="item_txt" v-if="item.isInterview">
                      <div>是</div>
                    </div>
                    <div class="item_txt" v-else>
                      <div>否</div>
                      <grayToolTipIcon :text="item.noInterviewArgument"></grayToolTipIcon>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 面试 -->
              <div class="details_box" v-else-if="item.talentProgress === '面试'">
                <div class="info_item">
                  <div class="item_title">方式：</div>
                  <div class="item_txt">
                    <div>{{ getInterviewTypeTxt(item, 1) }}</div>
                  </div>
                </div>
                <div class="info_item">
                  <div class="item_title">时间：</div>
                  <div class="item_txt">
                    <div>{{ item.interviewTime }}</div>
                  </div>
                </div>
                <div class="info_item">
                  <div class="item_title">
                    {{ getInterviewTypeTxt(item, 2) }}
                  </div>
                  <div class="item_txt">
                    <div>{{ getInterviewTypeTxt(item, 3) }}</div>
                  </div>
                </div>
                <div class="info_item">
                  <div class="item_title">面试官：</div>
                  <div class="item_txt">
                    <div>{{ item.interviewer }}</div>
                  </div>
                </div>
                <div class="info_item">
                  <div class="item_title">是否推进：</div>
                  <div class="item_txt" v-if="item.isPropel">
                    <div>是</div>
                  </div>
                  <div class="item_txt" v-else>
                    <div>否</div>
                    <grayToolTipIcon :text="item.noPropelArgument"></grayToolTipIcon>
                  </div>
                </div>
              </div>
              <!-- offer -->
              <div class="details_box" v-else-if="item.talentProgress === 'offer'">
                <div class="info_item">
                  <div class="item_title">offer进度：</div>
                  <div class="item_txt">
                    <div>
                      {{ getOfferProgressTxt(item.offerSchedule) }}
                    </div>
                    <grayToolTipIcon
                      v-if="item.offerSchedule === '3'"
                      :text="item.failArgument"
                    ></grayToolTipIcon>
                  </div>
                </div>
              </div>
              <!-- 回款 -->
              <div class="details_box" v-else>
                <div class="info_item">
                  <div class="item_title">入职时间：</div>
                  <div class="item_txt">
                    <div>{{ item.entryTime }}</div>
                    <div>
                      {{ item.isEntry ? '已入职' : '距入职' + item.daysOnDuty + '天' }}
                    </div>
                  </div>
                </div>
                <div class="info_item">
                  <div class="item_title">保证期：</div>
                  <div class="item_txt">
                    <div>
                      {{ getPromiseTime(item.guaranteePeriod) }}
                    </div>
                  </div>
                </div>
                <div class="info_item">
                  <div class="item_title">保证期结果：</div>
                  <div class="item_txt" v-if="item.isGuaranteePeriod">
                    <div>已通过</div>
                  </div>
                  <div class="item_txt" v-else>
                    <div>未通过</div>
                    <grayToolTipIcon :text="item.noGuaranteePeriodArgument"></grayToolTipIcon>
                  </div>
                </div>
                <div class="info_item">
                  <div class="item_title">已收回款：</div>
                  <div class="item_txt">
                    <div>{{ item.recoveredMoney + 'W' }}</div>
                  </div>
                </div>
                <div class="info_item">
                  <div class="item_title">未收回款：</div>
                  <div class="item_txt">
                    <div>{{ item.uncollectedMoney + 'W' }}</div>
                  </div>
                </div>
              </div>
              <!-- 编辑图标 -->
              <i class="el-icon-edit-outline" @click="showAddScheduleDialog(item.id, 1)"></i>
            </div>
          </li>
        </ul>
        <!-- table -->
        <!-- <div class="table_box" v-if="addSchedule != []">
            <div class="he">
              <div class="stage">人才进度</div>
              <div class="rate_of_progress">进度详况</div>
              <div class="options_name">操作顾问</div>
              <div class="newTime">最近更新时间</div>
            </div>

            <div class="items" v-for="item in addSchedule" :key="item.id">
              <div class="stage">{{ item.talentProgress }}</div>
              <div class="rate_of_progress">{{ item.talentDetails }}</div>
              <div class="options_name">{{ item.operationConsultant }}</div>
              <div class="newTime">{{ item.updateTime }}</div>
            </div>

            <div class="pagination_box">
              <el-pagination
                @size-change="handleSizeChangeDialog"
                @current-change="handleCurrentChangeDialog"
                :current-page="1"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dialogTotal"
              >
              </el-pagination>
            </div>
          </div> -->
      </el-dialog>
      <el-dialog
        :title="'添加进度'"
        @close="closeScheduleDialogVisible"
        :visible.sync="addScheduleDialogVisible"
        width="50%"
      >
        <el-form
          class="record_from"
          ref="recordFrom"
          :rules="rules"
          style="margin-top: 20px"
          :model="recordFrom"
          label-width="140px"
        >
          <el-form-item label="人才进度：" prop="talentProgress">
            <el-select
              v-model="recordFrom.talentProgress"
              placeholder="请选择"
              @change="talentProgressChanged"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="recordFrom.talentProgress === '触达'">
            <el-form-item prop="isReach" label="是否触达：">
              <el-radio-group v-model="recordFrom.isReach">
                <el-radio :label="false">未触达</el-radio>
                <el-radio :label="true">已触达</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="!recordFrom.isReach">
              <el-form-item prop="source" label="来源：">
                <el-radio-group v-model="recordFrom.source">
                  <el-radio v-for="item in sourceList" :key="item.id" :label="item.id">{{
                    item.value
                  }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="isCurriculumVitae" label="简历：">
                <el-radio-group v-model="recordFrom.isCurriculumVitae">
                  <el-radio :label="true">有</el-radio>
                  <el-radio :label="false">无</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="isContactInformation" label="联系方式：">
                <el-radio-group v-model="recordFrom.isContactInformation">
                  <el-radio :label="true">有</el-radio>
                  <el-radio :label="false">无</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item prop="reachSchedules" label="触达进度：">
                <el-checkbox-group v-model="recordFrom.reachSchedules">
                  <el-checkbox v-for="item in touchProgressList" :key="item.id" :label="item.id">{{
                    item.label
                  }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item prop="reachResult" label="触达结果：">
                <el-radio-group
                  v-model="recordFrom.reachResult"
                  @change="radioSelectChange($event, 'reachResult')"
                >
                  <el-radio v-for="item in touchResultList" :key="item.id" :label="item.id">
                    {{ item.label }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
          <div v-else-if="recordFrom.talentProgress === '推荐'">
            <el-form-item prop="isRecommended" label="是否推荐：">
              <el-radio-group v-model="recordFrom.isRecommended">
                <el-radio :label="false">未推荐</el-radio>
                <el-radio :label="true">已推荐</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="!recordFrom.isRecommended">
              <el-form-item label="人才报告：">
                <el-button style="width: 100px" type="primary" @click="clickToCompile(queryItem)">
                  去编辑
                </el-button>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item prop="recommendedTime" label="推荐日期：">
                <el-date-picker
                  v-model="recordFrom.recommendedTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="isFeedback" label="客户反馈：">
                <el-radio-group v-model="recordFrom.isFeedback">
                  <el-radio :label="false">未反馈</el-radio>
                  <el-radio :label="true">已反馈</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                prop="uploadAttachments"
                label="上传人才报告："
                v-if="!recordFrom.isFeedback"
              >
                <uploadFileMine
                  class="upload"
                  :lookUrl.sync="recordFrom.uploadAttachments"
                  :saveUrl.sync="recordFrom.uploadAttachmentsKey"
                  btnTxt="上传报告"
                />
              </el-form-item>
              <el-form-item prop="isInterview" label="是否面试：" v-else>
                <el-radio-group
                  v-model="recordFrom.isInterview"
                  @change="radioSelectChange($event, 'isInterview')"
                >
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
                <template v-if="!recordFrom.isInterview">
                  <el-form-item>
                    <el-radio-group v-model="recordFrom.dieOutReason">
                      <el-radio label="0">查重</el-radio>
                      <el-radio label="1">弃权</el-radio>
                      <el-radio label="2">不合适</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      type="textarea"
                      :rows="4"
                      v-model="recordFrom.noInterviewArgument"
                      placeholder="请输入原因"
                    ></el-input>
                  </el-form-item>
                </template>
              </el-form-item>
            </div>
          </div>
          <div v-else-if="recordFrom.talentProgress === '面试'">
            <el-form-item prop="interviewProgress" label="面试进度：">
              <el-radio-group v-model="recordFrom.interviewProgress">
                <el-radio label="1">初试</el-radio>
                <el-radio label="2">复试</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item prop="way" label="方式：">
              <el-radio-group v-model="recordFrom.way">
                <el-radio label="1">现场</el-radio>
                <el-radio label="2">视频</el-radio>
                <el-radio label="3">电话</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="mr-b-20" prop="interviewTime" label="时间：">
              <el-date-picker
                v-model="recordFrom.interviewTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
            <div v-if="recordFrom.way === '1'">
              <el-form-item class="mr-b-20" prop="locations" label="地点：">
                <el-input v-model="recordFrom.locations" placeholder=""></el-input>
              </el-form-item>
            </div>
            <div v-else-if="recordFrom.way === '2'">
              <el-form-item class="mr-b-20" prop="link" label="链接：">
                <el-input v-model="recordFrom.link" placeholder=""></el-input>
              </el-form-item>
            </div>
            <div v-else-if="recordFrom.way === '3'">
              <el-form-item class="mr-b-20" prop="phone" label="联系方式：">
                <el-input v-model="recordFrom.phone" placeholder=""></el-input>
              </el-form-item>
            </div>

            <el-form-item prop="interviewers" label="面试官：">
              <!-- 填写过一次后保留记录 搜索选择+新增数据 -->
              <div class="face_list">
                <!--  @select="handleSelectInterviewer($event, item, index)" -->
                <div v-for="(item, index) in inputInterviewers" :key="index" class="mini_input">
                  <el-autocomplete
                    v-model="inputInterviewers[index]"
                    :fetch-suggestions="querySearchInterviewer"
                    placeholder=""
                    @select="handleSelect(item, index)"
                  ></el-autocomplete>
                  <i class="el-icon-error" @click="deleteInterviewerInput(index)"></i>
                </div>
                <div class="add_btn" @click="addInterviewerInput">+添加面试官</div>
              </div>
              <!-- <el-input v-model="recordFrom.interviewer" placeholder=""></el-input> -->
            </el-form-item>
            <el-form-item prop="isPropel" label="是否推进：">
              <el-radio-group
                v-model="recordFrom.isPropel"
                @change="radioSelectChange($event, 'isPropel')"
              >
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
              <el-form-item prop="noPropelArgument" v-if="!recordFrom.isPropel">
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="recordFrom.noPropelArgument"
                  placeholder="请输入原因"
                ></el-input>
              </el-form-item>
            </el-form-item>
          </div>
          <div v-else-if="recordFrom.talentProgress === 'offer'">
            <el-form-item prop="offerSchedule" label="offer进度：">
              <el-radio-group v-model="recordFrom.offerSchedule">
                <el-radio label="1">谈判</el-radio>
                <el-radio label="2">等待入职</el-radio>
                <el-radio label="3">fail</el-radio>
              </el-radio-group>
              <el-form-item prop="failArgument" v-if="recordFrom.offerSchedule === '3'">
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="recordFrom.failArgument"
                  placeholder="请输入原因"
                ></el-input>
              </el-form-item>
            </el-form-item>
            <div v-if="recordFrom.offerSchedule === '2'">
              <el-form-item class="mr-b-20" prop="awaitEntryTime" label="入职时间：">
                <el-date-picker
                  v-model="recordFrom.awaitEntryTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="salaryTreatment" label="薪资待遇：">
                <div class="chlid_input_box">
                  <!-- <el-input
                        v-model="recordFrom.recoveredMoney"
                        @input="inputChange"
                        placeholder=""
                      ></el-input> -->
                  <el-input
                    @input="inputChangeoff"
                    v-model="recordFrom.salaryTreatment"
                    placeholder=""
                    style="width: 220px"
                  ></el-input>

                  <span class="txt" style="padding-left: 6px">W</span>
                </div>
              </el-form-item>
            </div>
          </div>
          <div v-else-if="recordFrom.talentProgress === '回款'">
            <el-form-item prop="entryTime" label="入职时间：">
              <!-- <el-input v-model="recordFrom.entryTime" placeholder="" readonly></el-input> -->
              <el-date-picker
                v-model="recordFrom.entryTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                @change="getEntryTimeInfo"
              >
              </el-date-picker>
              <div
                v-if="recordFrom.daysOnDuty || recordFrom.daysOnDuty === 0"
                style="line-height: 30px"
              >
                {{ (recordFrom.isEntry ? '已入职' : '距入职') + (recordFrom.daysOnDuty + '天') }}
              </div>
            </el-form-item>
            <el-form-item prop="guaranteePeriod" label="保证期：">
              <el-select v-model="recordFrom.guaranteePeriod">
                <el-option
                  v-for="item in promiseDurationList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="isGuaranteePeriod" label="保证期结果：">
              <el-radio-group v-model="recordFrom.isGuaranteePeriod">
                <el-radio :label="true">保证期通过</el-radio>
                <el-radio :label="false">保证期不通过</el-radio>
              </el-radio-group>
              <div class="child_item_box">
                <el-form-item
                  class="mr-b-20"
                  prop="recoveredMoney"
                  label="已收回款："
                  label-width="100px"
                >
                  <div class="chlid_input_box">
                    <el-input
                      v-model="recordFrom.recoveredMoney"
                      @input="inputChange"
                      placeholder=""
                      style="width: 220px"
                    ></el-input>
                    <span class="txt" style="padding-left: 6px">W</span>
                  </div>
                </el-form-item>
                <el-form-item
                  class="mr-b-20"
                  prop="uncollectedMoney"
                  label="未收回款："
                  label-width="100px"
                >
                  <div class="chlid_input_box">
                    <el-input
                      v-model="recordFrom.uncollectedMoney"
                      @input="inputChangeNo"
                      placeholder=""
                      style="width: 220px; margin-top: 16px"
                    ></el-input>
                    <span class="txt" style="padding-left: 6px">W</span>
                  </div>
                </el-form-item>
                <el-form-item
                  v-if="!recordFrom.isGuaranteePeriod"
                  class="mr-b-20"
                  prop="noGuaranteePeriodArgument"
                  label=""
                  label-width="100px"
                >
                  <el-input
                    type="textarea"
                    :rows="4"
                    v-model="recordFrom.noGuaranteePeriodArgument"
                    placeholder="请输入原因"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button v-show="showRemoveBtn" @click="removePersonBtn">移除沟通列表</el-button>
          <el-button
            v-show="recordFrom.talentProgress === '面试' && recordFrom.isPropel"
            @click="showInterviewDialog"
            >生成面试邀约</el-button
          >
          <el-button type="primary" @click="submitForm">添加</el-button>
          <el-button @click="addScheduleDialogVisible = false">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog @close="closeCopyVisible" :visible.sync="copyVisible" width="50%">
        <div class="copy_item" ref="contentToCopy">
          <div class="copy_text">面试已确定！细节如下：</div>
          <div class="copy_text">公司：{{ levelItem.corporateName }}</div>
          <div class="copy_text">职位：{{ levelItem.recruitmentPosition }}</div>
          <div class="copy_text">时间：{{ copyObj.interviewTime }}</div>
          <div class="copy_text" v-if="copyObj.way === '1'">方式：现场</div>
          <div class="copy_text" v-if="copyObj.way === '2'">方式：视频</div>
          <div class="copy_text" v-if="copyObj.way === '3'">方式：电话</div>

          <div class="copy_text" v-if="copyObj.way === '1'">地点：{{ copyObj.locations }}</div>
          <div class="copy_text" v-if="copyObj.way === '2'">链接：{{ copyObj.link }}</div>
          <div class="copy_text" v-if="copyObj.way === '3'">联系方式：{{ copyObj.phone }}</div>

          <div class="copy_text">有任何问题或特殊情况（如迟到）请及时联系我。祝面试顺利！</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="copyClick">复制</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 添加候选人对话框 -->
    <div class="addCandidateDialog">
      <el-dialog :visible.sync="addCandidateDialog" width="880px" @close="handleClose">
        <span slot="title" class="dialog-footer">
          <div class="head_title">
            <div class="line"></div>
            <div class="txt">添加候选人</div>
            <div class="search_candidate">
              <el-input
                v-model="query.name"
                placeholder="请输入关键词"
                clearable
                @change="clear_input"
              >
              </el-input>
              <div @click="search_candidate" class="search_candidate_box">
                <i style="color: #fff" class="el-icon-search"></i>
              </div>
            </div>
          </div>
        </span>
        <div class="addCandidateDialog_main">
          <div class="addCandidateDialog_main_title">
            <div>共匹配到{{ total }}位候选人</div>
            <div class="addCandidateDialog_main_title_right">
              已选<span class="select">{{ selectSum }}</span>
            </div>
          </div>

          <div class="addCandidateDialog_main_box">
            <!-- 每一项 -->
            <div
              class="addCandidateDialog_main_item"
              v-for="(item, index) in addCandidateDialogList"
              :key="index"
            >
              <div class="left">
                <!-- 勾选按钮 -->
                <div class="check">
                  <el-checkbox
                    @change="CandidateCheckbox(item, index)"
                    v-model="item.isPitchOn"
                  ></el-checkbox>
                </div>
                <!-- 头像 -->
                <div class="img_box">
                  <img :src="item.headPortraits" alt="" class="img" />
                </div>
                <!-- 信息 -->
                <div class="info">
                  <div class="userName">{{ item.name }}</div>
                  <div
                    class="shool"
                    v-if="item.personEducational && item.personEducational.length != 0"
                  >
                    <i class="el-icon-office-building" style="color: #17757a"></i>
                    <span style="margin-left: 6px"
                      >{{ item.personEducational[0].schoolName }}
                      {{ item.personEducational[0].major }}
                      {{ item.personEducational[0].education }}</span
                    >
                  </div>
                  <div class="else">
                    {{ item.personType }} <span class="else_line"></span> {{ item.workingYears }}
                    <div class="else_line"></div>
                    {{ item.personProvince }}-{{ item.personCity }}
                  </div>
                </div>
              </div>

              <div class="right">
                <!-- 匹配度 -->
                <!-- <div class="matching_rate">
                  匹配度
                  <el-progress
                    :width="16"
                    :show-text="false"
                    :stroke-width="2"
                    type="circle"
                    :percentage="75"
                    style="margin: 0 2px 0 5px"
                    color="#17757a"
                  ></el-progress>
                  75%
                </div> -->

                <!-- 查看详情 -->
                <div class="details">查看详情</div>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="pagination_box">
            <el-pagination
              @size-change="handleSizeChangeDialogR"
              @current-change="handleCurrentChangeDialogR"
              :current-page="1"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalTwo"
            >
            </el-pagination>
          </div>
          <!-- 操作按钮 -->
          <div class="btn_list">
            <div class="add" @click="clickAddSaveIntermediate">添加</div>
            <div class="cancel" @click="addCandidateDialog = false">取消</div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import CascaderArea from '@/components/CascaderArea'
// import { codeType } from '@/api/projectCenter.js'
// codeType 008 查询职位类型
import { codeType } from '@/api/common.js'
import {
  selectProjectCenterNumber,
  selectPersonChosenNumber,
  getHomePage,
  saveIntermediateListTwo,
  deleteIntermediate,
  selectExist
} from '@/api/projectCenter.js'
import { selectIntermediate, progressCntNew } from '@/api/jingyiProject.js'
import {
  deleteIntermediateTwo,
  selectCandidateRecords,
  saveCandidateRecords,
  updateCandidateRecords,
  getPersonProgressById,
  selectInterviewer,
  selectPersonScheduleId,
  computeDayNumber,
  deletePersonRelateProject
} from '@/api/projectCenter.js'
import uploadFileMine from '../projectCenter/workbench/components/uploadFileMine.vue'
import UpLoad from '@/components/UploadFileDIY.vue'
// 请求参数
const defaultQueryInfo = Object.freeze({
  // 页码数和页面大小
  baseParam: {
    pageNum: 1, // 页数
    pageSize: 10 // 大小
  },
  createTime: null, // 添加时间desc,asc
  expectedCity: '', // 期望城市
  expectedCountry: '', // 期望国家
  expectedProvince: '', // 期望省份
  id: 0, // 项目id
  keyword: '', //关键字
  notInterested: '', //不感兴趣（传1）
  personType: '', // 职位类型
  progressTalent: null, // 人才进度desc,asc
  projectSchedule: '沟通列表', // 候选人传null；沟通列表：全部传->沟通列表，筛选的人才进度正常传值；岗位推荐->岗位推荐
  reviewStatus: '', //审核状态 0 未审核 1 审核成功 2 审核失败
  reviewStatusSort: '', //审核状态desc,asc
  updateTime: null, // 最近更新时间desc,asc
  workingYears: '' //  工作经验/工作年限(1->1;2->1~3;3->3~5;4->5~10;5->10)
})
const defauleRecordFrom = Object.freeze({
  daysOnDuty: 0,
  isEntry: true,
  updateName: '',
  updateTime: '',
  createName: '',
  createTime: '',
  operationConsultant: '',
  dieOutReason: '',
  noPropelArgument: '', // 面试-不推进原因
  failArgument: '', // offer-fail原因
  id: null, //id
  personnelId: null, //人才关联id
  projectId: null, //项目编号
  talentProgress: '触达', //人才进度
  isReach: false, // 是否触达
  source: '1', // 来源
  isCurriculumVitae: true, // 有无简历
  isContactInformation: true, // 有无联系方式
  reachSchedule: '', // 触达进度-一览展示用
  reachSchedules: [], // 触达进度集合-接口传参
  reachResult: '1', // 触达结果
  isRecommended: false, // 是否推荐
  recommendedTime: '', // 推荐日期
  isFeedback: false, // 是否反馈
  uploadAttachments: '', // 未反馈-上传附件
  isInterview: true, // 是否面试
  noInterviewArgument: '', // 已反馈-未面试-未安排面试理由
  interviewProgress: '1', // 面试进度
  way: '1', // 方式(1、现场；2、视频；3、电话)
  interviewTime: '', // 面试时间
  interviewer: '', // 面试官-一览展示用
  interviewers: [], // 面试官集合-接口传参
  locations: '', // 现场面试-地点
  link: '', // 视频面试-链接
  phone: '', // 电话面试-联系方式
  isPropel: true, // 是否推进
  offerSchedule: '1', // offer进度：1、谈判；2、等待入职；3、fail
  awaitEntryTime: '', // offer-等待入职-入职时间
  salaryTreatment: '', // offer-等待入职-薪资待遇
  entryTime: '', // 回款-入职时间
  guaranteePeriod: '3', // 回款-保证期（月）
  isGuaranteePeriod: true, // 回款-保证期是否通过
  recoveredMoney: null, // 回款-已收回款
  uncollectedMoney: null, // 回款-未收回款
  noGuaranteePeriodArgument: '' // 回款-保证期未通过理由
})

export default {
  data() {
    const arrayCheck = (rule, value, callback) => {
      let txt = ''
      if (rule.field === 'reachSchedules') {
        // 校验 "触达进度" 时
        txt = '请选择触达进度'
        if (!value.length) {
          callback(new Error(txt))
        } else {
          callback()
        }
      } else if (rule.field === 'interviewers') {
        // 校验 "面试官" 时
        txt = '请设置面试官'
        let arr = []
        if (!value.length) {
          callback(new Error(txt))
        } else {
          value.forEach((el) => {
            if (el) {
              arr.push(el)
            }
          })
          if (arr.length !== value.length) {
            callback(new Error(txt))
          } else {
            callback()
          }
        }
      }
    }
    return {
      addCandidateDialogList: [],
      totalTwo: 0,
      addCandidateDialog: false,
      showBtnList: false, // 展示新增人才按钮列表
      myRadioActive: {
        border: '1px solid #17757a',
        color: '#17757a',
        borderRadius: '4px'
      },
      isShow: false, //是否显示 核心要求 全文
      getProjectCenterList: {
        projectCenterResult: {
          projectScheduleInt: 0
        }
      },
      candidateCount: 0, //候选人统计
      communicateCount: 0, //	沟通列表统计
      queryInfo: { ...defaultQueryInfo }, // 获取列表条数传参
      // 审核状态列表审核
      projectStatusList: [
        {
          codeName: '待审核',
          codeId: 0
        },
        {
          codeName: '审核通过',
          codeId: 1
        },
        {
          codeName: '审核不通过',
          codeId: 2
        }
      ],
      // 人才进度列表审核
      projectScheduleList: [
        {
          label: '触达',
          index: 0,
          value: 0
        },
        {
          label: '推荐',
          index: 1,
          value: 0
        },
        {
          label: '面试',
          index: 2,
          value: 0
        },
        {
          label: 'offer',
          index: 3,
          value: 0
        },
        {
          label: '回款',
          index: 4,
          value: 0
        },
        {
          label: '淘汰',
          index: 5,
          value: 0
        }
      ],
      // 人才进度列表
      experienceList: [
        {
          value: '不限',
          id: 0
        },
        {
          value: '1年',
          id: 1
        },
        {
          value: '1~3年',
          id: 2
        },
        {
          value: '3~5年',
          id: 3
        },
        {
          value: '5~10年',
          id: 4
        },
        {
          value: '10年以上',
          id: 5
        }
      ],
      experienceIndex: 0,
      projectScheduleIndex: 0, //人才选中
      // 职位类型
      positionTypeList: [],
      positionTypeIndex: 0,
      activeName: '', //手风琴
      noLimit: [], //项目状态数组
      codeData: [], //项目数据循环
      candidatesData: [], // 人选状态数组循环
      queryList: {}, //表格数据
      checked1: false, // 待审核复选框值
      talentI: 0, //按人才进度
      createStatusI: 0, //按新增时间
      updateStatusI: 0, // 按最近更新时间、审核状态
      reviewPendingNum: null, //待审核数量
      //项目更新进度时间
      projectNewsTime: {
        projectApprovalTime: '', //立项时间
        talentMappingTime: '', //人才mapping时间
        talentRecommendTime: '', //人才推荐时间
        interviewInvitationTime: '', //面试邀约时间
        offerNegotiationTime: '', //offer谈判时间
        offerAcceptTime: '', //offer接受时间
        entryTime: '', //入职时间
        endGuaranteePeriodTime: '' //保证期结束时间
      },
      copyObj: {}, //弹窗复制数据
      copyVisible: false,
      showRemoveBtn: false, // 是否显示移除沟通列表按钮 新增人才进度弹窗
      inputInterviewers: [''], // 设置的面试官列表
      interviewerList: [], // 查询到的面试官列表
      notInterested: false, // 是否感兴趣
      query: {
        beginAge: '',
        companyName: '',
        currentIndustry: '',
        finishAge: '',
        name: '',
        pageNum: 1,
        pageSize: 10,
        personCity: '',
        personCountry: '',
        personProvince: '',
        personSchedule: '',
        personType: [],
        position: '',
        state: '',
        workingYears: ''
      },
      addScheduleDialogVisible: false, // 新增编辑人才进度信息弹窗
      options: [
        {
          value: '触达',
          id: 0
        },
        {
          value: '推荐',
          id: 1
        },
        {
          value: '面试',
          id: 2
        },
        {
          value: 'offer',
          id: 3
        },
        {
          value: '回款',
          id: 4
        }
      ],
      // 触达阶段--来源
      sourceList: [
        {
          value: '猎聘',
          id: '1'
        },
        {
          value: 'BOSS',
          id: '2'
        },
        {
          value: '智联',
          id: '3'
        },
        {
          value: '拉勾',
          id: '4'
        },
        {
          value: '脉脉',
          id: '5'
        },
        {
          value: '其他',
          id: '6'
        }
      ],
      // 触达阶段--进度列表
      touchProgressList: [
        {
          label: '发JD',
          id: '1'
        },
        {
          label: '收简历',
          id: '2'
        },
        {
          label: '电话沟通',
          id: '3'
        },
        {
          label: '+V',
          id: '4'
        }
      ],
      // 触达阶段--结果列表
      touchResultList: [
        {
          label: '不感兴趣',
          id: '1'
        },
        {
          label: '不合适',
          id: '2'
        },
        {
          label: '查重',
          id: '3'
        },
        {
          label: '人才报告',
          id: '4'
        }
      ],
      // 回款阶段--保证期
      promiseDurationList: [
        {
          value: '1',
          label: '一个月'
        },
        {
          value: '2',
          label: '二个月'
        },
        {
          value: '3',
          label: '三个月'
        },
        {
          value: '4',
          label: '四个月'
        },
        {
          value: '5',
          label: '五个月'
        },
        {
          value: '6',
          label: '六个月'
        }
      ],
      rules: {
        talentProgress: [{ required: true, message: '请选择人才进度', trigger: 'change' }],
        isReach: [{ required: true, message: '', trigger: 'change' }],
        source: [{ required: true, message: '', trigger: 'change' }],
        isCurriculumVitae: [{ required: true, message: '', trigger: 'change' }],
        isContactInformation: [{ required: true, message: '', trigger: 'change' }],
        reachResult: [{ required: true, message: '', trigger: 'change' }],
        isRecommended: [{ required: true, message: '', trigger: 'change' }],
        isFeedback: [{ required: true, message: '', trigger: 'change' }],
        isInterview: [{ required: true, message: '', trigger: 'change' }],
        interviewProgress: [{ required: true, message: '', trigger: 'change' }],
        way: [{ required: true, message: '', trigger: 'change' }],
        isPropel: [{ required: true, message: '', trigger: 'change' }],
        offerSchedule: [{ required: true, message: '', trigger: 'change' }],
        guaranteePeriod: [{ required: true, message: '', trigger: 'change' }],
        recommendedTime: [{ required: true, message: '请选择推荐日期', trigger: 'change' }],
        uploadAttachments: [{ required: true, message: '请上传人才报告', trigger: 'blur' }],
        interviewTime: [{ required: true, message: '请选择面试时间', trigger: 'change,blur' }],
        locations: [{ required: true, message: '请输入地点', trigger: 'blur' }],
        link: [{ required: true, message: '请输入链接', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        awaitEntryTime: [{ required: true, message: '请选择入职时间', trigger: 'change' }],
        noPropelArgument: [{ required: true, message: '请输入原因', trigger: 'blur' }],
        failArgument: [{ required: true, message: '请输入原因', trigger: 'blur' }],
        noGuaranteePeriodArgument: [{ required: true, message: '请输入原因', trigger: 'blur' }],
        salaryTreatment: [{ required: true, message: '请输入薪资待遇', trigger: 'blur' }],
        reachSchedules: [{ required: true, validator: arrayCheck, trigger: 'change' }],
        interviewers: [{ required: true, validator: arrayCheck, trigger: 'change' }],
        entryTime: [{ required: true, message: '请选择入职时间', trigger: 'change,blur' }],
        recoveredMoney: [{ required: true, message: '请输入已收回款', trigger: 'blur' }],
        uncollectedMoney: [{ required: true, message: '请输入未收回款', trigger: 'blur' }]
      },
      // queryList: [
      //   {
      //     personEducational: [
      //       {
      //         education: ''
      //       }
      //     ]
      //   }
      // ],
      total: 0,
      searchKeyword: '',
      checked: false,
      selectSum: 0,
      candidateIdList: [],
      addScheduleClass: 0,
      addTimeClass: 0,
      addNewTimeClass: 0,
      idList: [],
      addSchedule: [],
      querySchedule: {
        id: '',
        order: '',
        pageNum: 1,
        pageSize: 10,
        projectId: 0
      },
      dialogVisible: false,
      queryItem: {},
      dialogTotal: 0,
      recordFrom: { ...defauleRecordFrom }, // 新增/编辑人才进度表单
      personCodeItem: '' // 候选人id
    }
  },
  components: {
    // radioSelect,
    CascaderArea,
    uploadFileMine,
    UpLoad
  },
  props: {
    queryInfoCopy: {
      type: Object
    }
  },
  computed: {
    // 拿到项目id
    id() {
      return this.$route.query.id
    },
    // 从上级页面带过来的数据
    levelItem() {
      return JSON.parse(this.$route.query.levelItem)
    },
    getTagBoxClass() {
      return function (item) {
        const { talentProgress } = item
        let className = ''

        if (talentProgress === '触达' && item.isReach) {
          className = 'yello'
        } else if (talentProgress === '推荐') {
          className = 'tuijian'
        } else if (talentProgress === '面试') {
          if (item.interviewProgress) {
            className = 'chushi'
          } else {
            className = 'fushi'
          }
        } else if (talentProgress === 'offer') {
          className = 'offer'
        } else if (talentProgress === '回款') {
          className = 'huikuan'
        }
        return className
      }
    },
    getTagTxt() {
      return function (item) {
        const { talentProgress } = item
        let txt = ''

        if (talentProgress === '触达') {
          txt = item.isReach ? '已触达' : '未触达'
        } else if (talentProgress === '推荐') {
          txt = item.isRecommended ? '已推荐' : '未推荐'
        } else if (talentProgress === '面试') {
          txt = item.interviewProgress ? '初试' : '复试'
        } else if (talentProgress === 'offer') {
          txt = 'offer'
        } else if (talentProgress === '回款') {
          txt = '回款'
        }
        return txt
      }
    },
    // 获取 触达-来源 展示
    getReachSourceTxt() {
      return function (type) {
        let txt = ''
        switch (type) {
          case '1':
            txt = '猎聘'
            break
          case '2':
            txt = 'boos'
            break
          case '3':
            txt = '智联'
            break
          case '4':
            txt = '拉勾'
            break
          case '5':
            txt = '脉脉'
            break
          case '6':
            txt = '其他'
            break
          default:
            break
        }
        return txt
      }
    },
    // 获取 触达-结果 展示
    getReachResultTxt() {
      return function (type) {
        let txt = ''
        switch (type) {
          case '1':
            txt = '不感兴趣'
            break
          case '2':
            txt = '不合适'
            break
          case '3':
            txt = '查重'
            break
          case '4':
            txt = '人才报告'
            break
          default:
            break
        }
        return txt
      }
    },
    // 获取面试方式
    getInterviewTypeTxt() {
      return function (item, val) {
        const { type } = item.way
        let txt = ''
        let name = ''
        let content = ''
        if (type === 1) {
          txt = '现场'
          name = '地点'
          content = item.locations
        } else if (type === 2) {
          txt = '视频'
          name = '链接'
          content = item.link
        } else {
          txt = '电话'
          name = '联系方式'
          content = item.phone
        }
        if (val === 1) {
          // 面试方式的内容
          return txt
        } else if (val == 2) {
          // 地点or链接or联系方式
          return name
        } else {
          // 地点or链接or联系方式的内容
          return content
        }
      }
    },
    // 获取offer进度展示
    getOfferProgressTxt() {
      return function (type) {
        let txt = ''
        switch (type) {
          case '1':
            txt = '谈判'
            break
          case '2':
            txt = '等待入职'
            break
          case '3':
            txt = 'fail'
            break
          default:
            break
        }
        return txt
      }
    },
    // 获取保证期时长展示
    getPromiseTime() {
      return function (type) {
        let txt = ''
        switch (type) {
          case '1':
            txt = '1个月'
            break
          case '2':
            txt = '2个月'
            break
          case '3':
            txt = '3个月'
            break
          case '4':
            txt = '4个月'
            break
          case '5':
            txt = '5个月'
            break
          case '6':
            txt = '6个月'
            break
          default:
            break
        }
        return txt
      }
    },
    item() {
      return JSON.parse(this.$route.query.item)
    }
  },
  created() {
    this.getPositionType()
    this.searchTable()
    this.getProgressCntNew()
    this.findOne()
  },
  methods: {
    ishttp(url) {
      return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1
    },
    // 点击下载简历
    clickDownload(row) {
      const path = row.file
      if (this.ishttp(row.file)) {
        // http(s):// 路径新窗口打开
        const pindex = path.indexOf('http')
        window.open(path.substr(pindex, path.length), '_blank')
      } else {
        this.$router.push(row.file)
      }
    },
    // 定时器--隐藏新增人才按钮列表
    addTimeoutHandle() {
      this.showBtnListTimer = setTimeout(() => {
        this.showBtnList = false
      }, 500)
    },
    async CandidateCheckbox(item, index) {
      if (item.isPitchOn == true) {
        let query = {
          personCode: item.personCode,
          projectId: JSON.parse(this.$route.query.item).id * 1
        }
        const { data: res } = await selectExist(query)
        if (res.data == true) {
          this.$message('这条数据已在列表中,请勿重复添加')
          return (this.addCandidateDialogList[index].isPitchOn = false)
        }
      }

      this.selectSum = 0
      this.candidateIdList = []
      this.addCandidateDialogList.forEach((item, index) => {
        if (item.isPitchOn == true) {
          this.selectSum++
          this.candidateIdList.push(item.personCode)
        }
      })
    },
    async search_candidate() {
      const { data: res } = await getHomePage(this.query)
      this.addCandidateDialogList = res.data.content
      // console.log("人才数据",res.data.content);
    },
    async clear_input(val) {
      if (!val) {
        const { data: res } = await getHomePage(this.query)
        this.addCandidateDialogList = res.data.content
      }
    },
    // 关闭
    handleClose() {
      this.candidateIdList = []
      this.query = {
        beginAge: '',
        companyName: '',
        currentIndustry: '',
        finishAge: '',
        name: '',
        pageNum: 1,
        pageSize: 10,
        personCity: '',
        personCountry: '',
        personProvince: '',
        personSchedule: '',
        personType: [],
        position: '',
        state: '',
        workingYears: ''
      }
    },
    async handleCommand(command) {
      if (command == '本地新增') {
        this.$router.push({
          name: 'TalentMessage',
          query: {
            searchInfo: JSON.stringify(this.queryInfo),
            uploadState: 'true',
            projectAddId: this.item.id
          }
        })
      } else if (command == '从人才库新增') {
        // 人才es查询
        const { data: res } = await getHomePage(this.query)
        if (res.code == 200) {
          console.log(res)
          this.addCandidateDialogList = res.data.content
          this.totalTwo = res.titleCount
        }
        this.addCandidateDialog = true
      }
      // else if (command == '本地新增') {
      // }
    },
    // 分页
    handleSizeChangeDialogR(val) {
      this.query.pageSize = val
      this.handleCommand('从人才库新增')
    },
    handleCurrentChangeDialogR(val) {
      this.query.pageNum = val
      this.handleCommand('从人才库新增')
    },
    async clickAddSaveIntermediate() {
      console.log(this.candidateIdList)
      if (this.candidateIdList.length == 0) {
        return this.$message('请勾选数据后重试')
      }
      const { data: res } = await saveIntermediateListTwo({
        personCode: this.candidateIdList,
        projectId: JSON.parse(this.$route.query.item).id
      })
      if (res.resultCode == 200) {
        this.$message.success('添加成功')
        this.search()
      }

      this.addCandidateDialog = false
    },
    async removeh() {
      let ids = this.idList
      const { data: res } = await deleteIntermediate(ids)
      if (res.resultCode == 200) {
        console.log(res)
        this.$message.success('删除成功')
        this.search()
      }
    },
    async addPersonBtnClick(id) {
      if (id === 1) {
        // 本地新增
        this.$router.push({
          name: 'TalentMessage',
          query: {
            searchInfo: JSON.stringify(this.queryInfo),
            uploadState: 'true',
            projectAddId: this.item.id
          }
        })
      } else {
        // 人才库新增
        this.query.personCountry = '中国'
        const { data: res } = await getHomePage(this.query)
        if (res.code === 200) {
          this.addCandidateDialogList = res.data.content
          this.totalTwo = res.titleCount
        }
        this.addCandidateDialog = true
      }
    },
    // 本地上传返回code  手动新增
    async uploadPersonCode(val) {
      console.log(val)
      let personCode = []
      personCode.push(val)
      const { data: res } = await saveIntermediateListTwo({
        personCode: personCode,
        projectId: JSON.parse(this.$route.query.item).id
      })
      if (res.resultCode == 200) {
        this.$message.success('添加成功')
        this.search()
      }
    },
    // 显示新增人才按钮列表
    showBtnListHandle() {
      if (this.showBtnListTimer) {
        clearTimeout(this.showBtnListTimer)
        this.showBtnListTimer = null
      }
      if (!this.showBtnList) {
        this.showBtnList = true
      }
    },

    // 隐藏新增人才按钮列表
    hideBtnlistHandle() {
      if (this.showBtnList) {
        this.addTimeoutHandle()
      }
    },
    // 地点查询
    // searchArae(val) {
    //   this.queryInfo.expectedCountry = val.country
    //   this.queryInfo.expectedCity = val.province
    //   this.queryInfo.expectedProvince = val.city
    //   this.search()
    // },
    async search() {
      this.queryInfo.id = JSON.parse(this.$route.query.levelItem).id
      const { data: res } = await selectIntermediate(this.queryInfo)
      if (res.resultCode == 200) {
        this.queryList = res.data.list
        this.total = res.data.total
        this.$emit('setTabTotal', 2, this.total)
      }
    },
    // // 选中不感兴趣
    // interestedChanged(val) {
    //   this.queryInfo.notInterested = val ? '1' : ''
    //   this.search()
    // },
    // // 选中人才进度进行筛选
    // changeSchedule(val) {},
    // async getPositionType() {
    //   const { data: res } = await codeType({
    //     code: '008'
    //   })
    //   // console.log(res)
    //   if (res.resultCode == 200) {
    //     this.positionTypeList = res.data
    //     this.positionTypeList.unshift({
    //       codeName: '不限',
    //       codeId: 0,
    //       codeType: '008'
    //     })
    //   }
    // },
    // clickExperience(item, index) {
    //   this.experienceIndex = index
    //   if (item.id == 0) {
    //     this.queryInfo.workingYears = ''
    //     this.search()
    //   } else {
    //     this.queryInfo.workingYears = item.id
    //     this.search()
    //   }
    // },
    // clickPositionTypeItem(item, index) {
    //   // console.log(item)
    //   this.positionTypeIndex = index
    //   if (item.id == 0) {
    //     this.queryInfo.personType = ''
    //     this.search()
    //   } else {
    //     this.queryInfo.personType = item.codeName
    //     this.search()
    //   }
    // },
    // // 分页
    // handleSizeChange(val) {
    //   this.queryInfo.baseParam.pageSize = val
    //   this.search()
    // },
    // handleCurrentChange(val) {
    //   this.queryInfo.baseParam.pageNum = val
    //   this.search()
    // },
    // 搜索
    // searchKeywordChange() {
    //   // console.log(this.searchKeyword)
    //   return this.$message('敬请期待!')
    // },
    // 打开生成面试邀约弹窗
    showInterviewDialog() {
      this.$refs.recordFrom.validate(async (valid) => {
        if (valid) {
          this.copyObj = { ...this.recordFrom }
          this.addScheduleDialogVisible = false
          this.copyVisible = true
        } else {
          this.$message.error('校验失败!')
        }
      })
    },
    //生成面试邀约的复制功能
    async copyClick() {
      try {
        const content = this.$refs.contentToCopy.innerText
        await navigator.clipboard.writeText(content)
        this.$message.success('内容已复制到剪贴板')
      } catch (err) {
        this.$message.error('网络地址不安全无法自动复制，请手动复制。')
      }
    },
    //关闭面试邀约的弹窗
    closeCopyVisible() {
      this.copyVisible = false
    },
    // 移除沟通列表按钮
    async removePersonBtn() {
      this.$confirm('移除后该人才将被退回至人才列表，确认移除吗?')
        .then(async () => {
          const query = {
            personCode: this.personCodeItem,
            projectId: this.levelItem.id
          }
          const { data: res } = await deletePersonRelateProject(query)
          if (res.resultCode === 200) {
            this.$message.success('移除成功!')
            this.closeScheduleDialogVisible()
          } else {
            this.$message.error('移除失败!')
          }
        })
        .catch(() => {})
    },
    // 提交表单前处理数据
    submitFormDataHadle() {
      let obj = this.recordFrom
      obj.projectId = this.levelItem.id
      obj.personnelId = this.personCodeItem
      // obj.createTime = null
      // obj.updateTime = null
      if (obj.talentProgress === '触达') {
        // 触达
        if (!obj.isReach) {
          // 选中的是未触达
          obj.reachSchedules = []
          obj.reachResult = '1'
        } else {
          // 选中的是已触达
          obj.source = '1'
          obj.isCurriculumVitae = true
          obj.isContactInformation = true
        }
      } else if (obj.talentProgress === '推荐') {
        // 推荐
        if (!obj.isRecommended) {
          // 选中的是未推荐
          obj.recommendedTime = ''
          obj.isFeedback = false
          obj.uploadAttachments = ''
        } else {
          // 选中的是已推荐
          if (obj.isFeedback) {
            // 选中的是已反馈
            obj.uploadAttachments = ''
            if (obj.isInterview) {
              // 是否面试选中 '是'
              obj.noInterviewArgument = ''
            }
          } else {
            // 选中的是未反馈
            obj.isInterview = true
            obj.noInterviewArgument = ''
          }
        }
      } else if (obj.talentProgress === '面试') {
        // 面试
        if (obj.way === '1') {
          // 现场
          obj.link = ''
          obj.phone = ''
        } else if (obj.way === '2') {
          // 视频
          obj.locations = ''
          obj.phone = ''
        } else if (obj.way === '3') {
          // 电话
          obj.locations = ''
          obj.link = ''
        }
        if (obj.isPropel) {
          // 是否推进选中 '是'
          obj.noPropelArgument = ''
        }
      } else if (obj.talentProgress === 'offer') {
        // offer
        if (obj.offerSchedule === '2') {
          // 等待入职
          obj.failArgument = ''
        } else {
          obj.awaitEntryTime = ''
          obj.salaryTreatment = ''
          if (obj.offerSchedule === '1') {
            // 谈判
            obj.failArgument = ''
          }
        }
      } else if (obj.talentProgress === '回款') {
        // 回款
        if (obj.isGuaranteePeriod) {
          // 保证期通过
          obj.noGuaranteePeriodArgument = ''
        }
      }
      // 已收回款、未收回款非空处理
      if (!obj.recoveredMoney) obj.recoveredMoney = 0
      if (!obj.uncollectedMoney) obj.uncollectedMoney = 0
      // 处理 '面试官' ,去除空值
      let arr = []
      if (obj.interviewers.length) {
        obj.interviewers.forEach((el) => {
          if (el) {
            arr.push(el)
          }
        })
      }
      obj.interviewers = arr
      Object.assign(this.recordFrom, obj)
      // 详情多返的字段，编辑传参前需要删除
      if (obj.hasOwnProperty('daysOnDuty')) delete this.recordFrom.daysOnDuty
      if (obj.hasOwnProperty('isEntry')) delete this.recordFrom.isEntry
      if (obj.hasOwnProperty('talentDetails')) delete this.recordFrom.talentDetails
      if (obj.hasOwnProperty('uploadAttachmentsKey')) delete this.recordFrom.uploadAttachmentsKey
    },
    // 新增、编辑人才进度-保存
    submitForm() {
      this.recordFrom.interviewers = this.inputInterviewers
      this.$refs.recordFrom.validate(async (valid) => {
        if (valid) {
          const id = this.recordFrom.id
          const fn = id ? updateCandidateRecords : saveCandidateRecords
          const txt = id ? '修改' : '新增'
          this.submitFormDataHadle()
          const { data: res } = await fn(this.recordFrom)
          if (res.resultCode == 200) {
            this.$emit('submitForm')
            this.$message.success(txt + '成功')
            this.closeScheduleDialogVisible()
          } else {
            this.$message.error(txt + '失败')
          }
        } else {
          this.$message.error('校验失败!')
        }
      })
    },
    // 关闭新增、编辑人才进度弹窗
    closeScheduleDialogVisible() {
      this.addScheduleDialogVisible = false
      this.recordFrom = { ...defauleRecordFrom }
      this.personCodeItem = ''
      this.queryItem = {}
      this.search()
    },
    // // 点击人才进度排序
    // clickSchedule() {
    //   this.addScheduleClass += 1
    //   // 清空另外俩个排序的状态
    //   this.addTimeClass = 0
    //   this.addNewTimeClass = 0
    //   this.queryInfo.createTime = null
    //   this.queryInfo.updateTime = null
    //   if (this.addScheduleClass == 3) {
    //     this.addScheduleClass = 0
    //   }
    //   if (this.addScheduleClass == 0) {
    //     this.queryInfo.progressTalent = null
    //     this.search()
    //   } else if (this.addScheduleClass == 1) {
    //     this.queryInfo.progressTalent = 'asc'
    //     this.search()
    //   } else if (this.addScheduleClass == 2) {
    //     this.queryInfo.progressTalent = 'desc'
    //     this.search()
    //   }
    // },
    // // 点击添加时间排序
    // clickAddTime() {
    //   this.addTimeClass += 1
    //   // 清空另外俩个排序的状态
    //   this.addNewTimeClass = 0
    //   this.addScheduleClass = 0
    //   this.queryInfo.progressTalent = null
    //   this.queryInfo.updateTime = null
    //   if (this.addTimeClass == 3) {
    //     this.addTimeClass = 0
    //   }
    //   if (this.addTimeClass == 0) {
    //     this.queryInfo.createTime = null
    //     this.search()
    //   } else if (this.addTimeClass == 1) {
    //     this.queryInfo.createTime = 'asc'
    //     this.search()
    //   } else if (this.addTimeClass == 2) {
    //     this.queryInfo.createTime = 'desc'
    //     this.search()
    //   }
    //   // console.log(this.addTimeClass)
    // },
    // // 点击最近更新时间排序
    // clickNewTime() {
    //   this.addNewTimeClass += 1
    //   // 清空另外俩个排序的状态
    //   this.addTimeClass = 0
    //   this.addScheduleClass = 0
    //   this.queryInfo.createTime = null
    //   this.queryInfo.progressTalent = null
    //   if (this.addNewTimeClass == 3) {
    //     this.addNewTimeClass = 0
    //   }
    //   if (this.addNewTimeClass == 0) {
    //     this.queryInfo.updateTime = null
    //     this.search()
    //   } else if (this.addNewTimeClass == 1) {
    //     this.queryInfo.updateTime = 'asc'
    //     this.search()
    //   } else if (this.addNewTimeClass == 2) {
    //     this.queryInfo.updateTime = 'desc'
    //     this.search()
    //   }
    //   // console.log(this.addNewTimeClass)
    // },
    //  选中候选人
    clickAddActive(item, index) {
      this.queryList[index].isSelected = !this.queryList[index].isSelected

      let idList = []
      this.queryList.forEach((item, index) => {
        if (item.isSelected) {
          idList.push(item)
        }
      })

      this.idList = idList
    },
    // 移除候选人
    async remove() {
      if (this.idList.length) {
        // let list = []
        // this.idList.forEach((item) => {
        //   list.push({
        //     id: item.id,
        //     personCode: item.personCode,
        //     projectId: item.projectId,
        //     talentProgress: null
        //   })
        // })
        let query = {
          personCode: [],
          projectId: this.levelItem.id
        }
        this.idList.forEach((item) => {
          query.personCode.push(item.personCode)
        })
        // const { data: res } = await updateIntermediate(list)
        const { data: res } = await deleteIntermediateTwo(query)

        // console.log(res);
        if (res.resultCode == 200) {
          this.$message.success('移除成功')
          this.search()
        }
      } else {
        this.$message.warning('请先选择候选人~')
      }
    },
    // 打开添加人才进度弹窗
    showAddScheduleDialog(id, val) {
      if (val === 1) {
        this.searchPersonProgress(id)
      } else {
        this.searchPersonScheduleId('触达')
      }
      this.dialogVisible = false
      this.addScheduleDialogVisible = true
    },
    // 根据人才进度id查询人才进度详情
    async searchPersonProgress(id) {
      const { data: res } = await getPersonProgressById({ id })
      if (res.resultCode === 200) {
        this.recordFrom = res.data
        // 触达进度非空处理
        if (!this.recordFrom.reachSchedules) {
          this.recordFrom.reachSchedules = []
        }
        // 面试官非空处理
        if (!this.recordFrom.interviewers) {
          this.recordFrom.interviewers = []
        }
        // 面试官详情
        if (res.data.interviewers) {
          this.inputInterviewers = res.data.interviewers
        }

        // 如果是回款阶段要查询入职时间
        if (res.data.talentProgress === '回款') {
          this.getEntryTimeInfo(res.data.entryTime)
        }
        this.getIsShowRemoveBtn()
      } else {
        this.$message.error('获取人才进度详情失败!')
      }
    },
    // 人才进度切换
    async talentProgressChanged(val) {
      this.searchPersonScheduleId(val)
      if (val === '回款') {
        // 回款需要拿offer的入职时间
        const query = {
          personCode: this.personCodeItem,
          personSchedule: 'offer',
          projectId: this.levelItem.id
        }
        const { data: res } = await selectPersonScheduleId(query)
        if (res.resultCode === 200) {
          const id = res.data
          if (id) {
            // 有人才进度id
            const { data: result } = await getPersonProgressById({ id })
            if (result.resultCode === 200) {
              const entryTime = result.data.awaitEntryTime
              this.$nextTick(() => {
                this.recordFrom.entryTime = entryTime
                this.getEntryTimeInfo(entryTime)
              })
            }
          }
        }
      }
    },
    // 获取入职状态和入职时间
    async getEntryTimeInfo(time) {
      if (!time) {
        this.recordFrom.daysOnDuty = 0
        this.recordFrom.isEntry = true
        return
      }
      this.recordFrom.daysOnDuty = 0
      this.recordFrom.isEntry = true
      const { data: res } = await computeDayNumber({ time })
      if (res.resultCode === 200) {
        this.recordFrom.daysOnDuty = res.data.daysOnDuty
        this.recordFrom.isEntry = res.data.isEntry
      }
      // console.log(this.recordFrom.isEntry ? '已入职' : '距入职' + this.recordFrom.daysOnDuty + '天')
    },
    // 获取人才进度id
    async searchPersonScheduleId(val) {
      const query = {
        personCode: this.personCodeItem,
        personSchedule: val,
        projectId: this.levelItem.id
      }
      const { data: res } = await selectPersonScheduleId(query)
      if (res.resultCode === 200) {
        const id = res.data
        if (id) {
          // 有人才进度id
          this.searchPersonProgress(id)
        } else {
          // 没有人才id
          this.recordFrom = { ...defauleRecordFrom }
          this.recordFrom.talentProgress = val
          this.getIsShowRemoveBtn()
        }
      }
    },
    // 查看人才详情
    edit(item) {
      this.$router.push({
        path: '/dataManagement/TalentMessage',
        query: {
          id: item.personCode,
          clientType: 1
        }
      })
    },
    // 点击更新进度
    clickNewest(item) {
      this.dialogVisible = true
      this.queryItem = item
      this.personCodeItem = item.personCode
      this.getSelectCandidateRecords(item)
    },
    // 查询人才进度列表
    async getSelectCandidateRecords(item) {
      this.querySchedule.projectId = item.projectId
      this.querySchedule.id = item.personCode

      const { data: res } = await selectCandidateRecords(this.querySchedule)
      if (res.resultCode == 200) {
        this.addSchedule = res.data.list
        this.dialogTotal = res.data.total
      }
    },
    // 人才进度列表弹窗关闭
    dialogClose() {
      this.addSchedule = []
    },
    // 分页
    handleSizeChangeDialog(val) {
      this.querySchedule.pageSize = val
      this.getSelectCandidateRecords(this.queryItem)
    },
    handleCurrentChangeDialog(val) {
      this.querySchedule.pageNum = val
      this.getSelectCandidateRecords(this.queryItem)
    },
    // 前往编辑报告
    clickToCompile(item) {
      console.log(item, 'item')
      item.corporateName = this.levelItem.corporateName
      item.recruitmentPosition = this.levelItem.recruitmentPosition
      item.projectManagers = this.levelItem.projectManagers
      this.$router.push({
        path: '/businessManagement/recommendedReport',
        query: {
          PreCode: item.personCode,
          id: item.id,
          item: JSON.stringify(item),
          type: '1',
          showAutingBtn: '0',
          projectId: JSON.parse(this.$route.query.levelItem).id,
          reviewCode: item.reviewCode,
          projectCode: item.projectId
        }
      })
    },
    // 查询面试官列表
    async querySearchInterviewer(str, cb) {
      this.interviewerList = []
      const { data: res } = await selectInterviewer({ interviewer: str })
      if (res.resultCode === 200) {
        if (res.data) {
          res.data.forEach((el) => {
            this.interviewerList.push({
              value: el
            })
          })
          cb(this.interviewerList)
        } else {
          cb(this.interviewerList)
        }
      } else {
        this.$message.error('查询失败！')
        cb(this.interviewerList)
      }
    },
    // 选中面试官名称
    async handleSelectInterviewer(val, item, index) {
      console.log(val)
      const { data: res } = await selectInterviewer({ interviewer: val })
      if (res.resultCode === 200) {
        if (res.data) {
          this.inputInterviewers[index] = res.data[0]
        } else {
          this.inputInterviewers[index] = []
        }
        this.interviewerList = []
      }
    },
    handleSelect(item, index) {
      this.recordFrom.interviewers = this.inputInterviewers
      // console.log(this.inputInterviewers[index]);
    },
    // 查询面试官输入值变化
    // handleChangeInterviewer(val) {
    //   this.interviewerList = []
    // },
    // 添加面试官输入框
    addInterviewerInput() {
      this.inputInterviewers.push('')
    },
    // 删除面试官输入框
    deleteInterviewerInput(index) {
      if (this.inputInterviewers.length > 1) {
        this.inputInterviewers.splice(index, 1)
      }
    },
    // 单选框选中值变化
    radioSelectChange(val, prop) {
      // val是组件传值;prop是区分调用的地方
      console.log(this.recordFrom.talentProgress)
      // this.getIsShowRemoveBtn()
    },
    // 计算是否显示 移除沟通列表 按钮
    getIsShowRemoveBtn() {
      if (this.recordFrom.talentProgress === '触达' && this.recordFrom.reachResult === '2') {
        this.showRemoveBtn = true
      } else if (this.recordFrom.talentProgress === '推荐' && !this.recordFrom.isInterview) {
        this.showRemoveBtn = true
      } else if (this.recordFrom.talentProgress === '面试' && !this.recordFrom.isPropel) {
        this.showRemoveBtn = true
      } else {
        this.showRemoveBtn = false
      }
    },
    inputChange(val) {
      this.recordFrom.recoveredMoney = val.replace(/[^0-9.]/g, '')
    },
    inputChangeoff(val) {
      this.recordFrom.salaryTreatment = val.replace(/[^0-9.]/g, '')
    },
    inputChangeNo(val) {
      this.recordFrom.uncollectedMoney = val.replace(/[^0-9.]/g, '')
    },
    // 查看简历
    openBiographical(row) {
      window.open(row.file)
    },
    //去人选审核页面
    toPersonAuting(item) {
      this.$router.push({
        path: '/businessManagement/recommendedReport',
        query: {
          item: JSON.stringify(item),
          PreCode: item.personCode,
          id: item.id,
          type: '1',
          reviewCode: item.reviewCode,
          showAutingBtn: '0'
        }
      })
    },
    //去人选审核页面
    toPersonAuting1(item) {
      this.$router.push({
        path: '/businessManagement/recommendedReport',
        query: {
          item: JSON.stringify(item),
          PreCode: item.personCode,
          id: item.id,
          type: '1',
          reviewCode: item.reviewCode,
          showAutingBtn: '1'
        }
      })
    },
    //审核状态查询
    searchStatus(val) {
      this.queryInfo.reviewStatus = val
      this.searchTable()
    },
    // 人才进度查询
    projectScheduleSearch(val) {
      this.queryInfo.projectSchedule = val.split('(')[0]
      this.searchTable()
    },
    //关键词搜索
    keywordSearch() {
      this.searchTable(this.queryInfo)
    },
    // 菁亿分配分页
    handleSizeChange(val) {
      this.queryInfo.baseParam.pageSize = val
      this.searchTable()
    },
    handleCurrentChange(val) {
      this.queryInfo.baseParam.pageNum = val
      this.searchTable()
    },
    // 表格数据查询
    async searchTable() {
      this.queryInfo.baseParam.pageNum = 1
      this.queryInfo.id = this.id
      const { data } = await selectIntermediate({
        ...this.queryInfo
      })

      if (data.resultCode == 200) {
        this.queryList = data.data.list
        this.total = data.data.total
      }
    },
    // 按人才进度排序
    uploadTalent() {
      this.queryInfo.baseParam.pageNum = 1
      switch (this.talentI) {
        case 0:
          this.queryInfo.progressTalent = 'asc'
          this.talentI++
          this.queryInfo.createTime = null
          this.queryInfo.updateTime = null
          this.queryInfo.reviewStatusSort = null
          break
        case 1:
          this.queryInfo.progressTalent = 'desc'
          this.talentI++
          this.queryInfo.createTime = null
          this.queryInfo.updateTime = null
          this.queryInfo.reviewStatusSort = null
          break
        case 2:
          this.queryInfo.progressTalent = ''
          this.talentI = 0
          this.queryInfo.createTime = null
          this.queryInfo.updateTime = null
          this.queryInfo.reviewStatusSort = null
          break
      }
      this.searchTable()
    },
    // 按新增时间排序
    uploadCreate() {
      this.queryInfo.baseParam.pageNum = 1
      switch (this.createStatusI) {
        case 0:
          this.queryInfo.createTime = 'asc'
          this.createStatusI++
          this.queryInfo.progressTalent = null
          this.queryInfo.updateTime = null
          this.queryInfo.reviewStatusSort = null
          break
        case 1:
          this.queryInfo.createTime = 'desc'
          this.createStatusI++
          this.queryInfo.progressTalent = null
          this.queryInfo.updateTime = null
          this.queryInfo.reviewStatusSort = null
          break
        case 2:
          this.queryInfo.createTime = ''
          this.createStatusI = 0
          this.queryInfo.progressTalent = null
          this.queryInfo.updateTime = null
          this.queryInfo.reviewStatusSort = null
          break
      }
      this.searchTable()
    },
    // 按最近更新时间排序
    updateStatus() {
      this.queryInfo.baseParam.pageNum = 1
      switch (this.updateStatusI) {
        case 0:
          this.queryInfo.updateTime = 'asc'
          this.updateStatusI++
          this.queryInfo.progressTalent = null
          this.queryInfo.createTime = null
          this.queryInfo.reviewStatusSort = null
          break
        case 1:
          this.queryInfo.updateTime = 'desc'
          this.updateStatusI++
          this.queryInfo.progressTalent = null
          this.queryInfo.createTime = null
          this.queryInfo.reviewStatusSort = null
          break
        case 2:
          this.queryInfo.updateTime = ''
          this.updateStatusI = 0
          this.queryInfo.progressTalent = null
          this.queryInfo.createTime = null
          this.queryInfo.reviewStatusSort = null
          break
      }
      this.searchTable()
    },
    // 按审核状态排序
    auditingStatus() {
      this.queryInfo.baseParam.pageNum = 1
      switch (this.updateStatusI) {
        case 0:
          this.queryInfo.reviewStatusSort = 'asc'
          this.updateStatusI++
          this.queryInfo.progressTalent = null
          this.queryInfo.createTime = null
          this.queryInfo.updateTime = null
          break
        case 1:
          this.queryInfo.reviewStatusSort = 'desc'
          this.updateStatusI++
          this.queryInfo.progressTalent = null
          this.queryInfo.createTime = null
          this.queryInfo.updateTime = null
          break
        case 2:
          this.queryInfo.reviewStatusSort = ''
          this.updateStatusI = 0
          this.queryInfo.progressTalent = null
          this.queryInfo.createTime = null
          this.queryInfo.updateTime = null
          break
      }
      this.searchTable()
    },
    // 待审核查询方法
    reviewStatusChange(val) {
      val ? (this.queryInfo.reviewStatus = 0) : (this.queryInfo.reviewStatus = '')
      this.searchTable()
    },
    // 根据查询参数查看项目人才进度相应的数量
    async getProgressCntNew() {
      const { data: res } = await progressCntNew(this.queryInfo)
      if (res.resultCode == 200) {
        this.reviewPendingNum = res.data[6]
        this.projectScheduleList.forEach((item) => {
          item.value = res.data[item.index]
        })
      }
    },
    // 查询单个
    findOne(row) {
      // console.log(row, 'row.personCode')
      // const { data } = await selectBYId({
      //   id: row.personCode
      // })
      // if (data.resultCode == 200) {
      //   this.projectNewsTime.projectApprovalTime = data.data.projectCenterResult.projectApprovalTime
      //   this.projectNewsTime.talentMappingTime = data.data.projectCenterResult.talentMappingTime
      //   this.projectNewsTime.talentRecommendTime = data.data.projectCenterResult.talentRecommendTime
      //   this.projectNewsTime.interviewInvitationTime =
      //     data.data.projectCenterResult.interviewInvitationTime
      //   this.projectNewsTime.offerNegotiationTime =
      //     data.data.projectCenterResult.offerNegotiationTime
      //   this.projectNewsTime.offerAcceptTime = data.data.projectCenterResult.offerAcceptTime
      //   this.projectNewsTime.entryTime = data.data.projectCenterResult.entryTime
      //   this.projectNewsTime.endGuaranteePeriodTime =
      //     data.data.projectCenterResult.endGuaranteePeriodTime
      // }
    },
    async getPositionType() {
      const { data: res } = await codeType({
        code: '008'
      })
      if (res.resultCode == 200) {
        this.positionTypeList = res.data
        this.positionTypeList.unshift({
          codeName: '不限',
          codeId: 0,
          codeType: '008'
        })
      }
    },
    // 地点查询
    searchArae(val) {
      this.queryInfo.expectedCountry = val.country
      this.queryInfo.expectedCity = val.city
      this.queryInfo.expectedProvince = val.province
      this.searchTable()
    },
    // 工作经验
    clickProjectSchedule(item, index) {
      this.projectScheduleIndex = index
    },
    // 工作经验
    clickExperience(item, index) {
      this.experienceIndex = index
      if (item.id == 0) {
        this.queryInfo.workingYears = ''
        this.searchTable()
      } else {
        this.queryInfo.workingYears = item.id
        this.searchTable()
      }
    },
    // 职位类型
    clickPositionTypeItem(item, index) {
      this.positionTypeIndex = index
      if (item.id == 0) {
        this.queryInfo.personType = ''
        this.searchTable()
      } else {
        this.queryInfo.personType = item.codeName
        this.searchTable()
      }
    },
    handleChange(val) {
      console.log(val)
      this.activeName = val
    },
    // 返回上级
    backPage() {
      this.$router.push({
        path: '/businessManagement/JingyiProject'
      })
    },
    // 清空项目搜索框
    cleanSearch(val) {
      if (val == '') this.search()
    },
    // 项目选择发生变化的时候
    limitClick() {
      if (this.queryInfoPro.projectStatus.length > 0) {
        ;(this.queryInfoPro.projectStatus = []), (this.noLimit = ['不限'])
        this.search()
      } else {
        this.noLimit = ['不限']
        this.search()
      }
    },
    // 多选发生变化时
    noLimitClick() {
      if (this.queryInfoPro.projectStatus.length > 0) {
        this.noLimit = []
        this.search()
      } else {
        this.noLimit = ['不限']
        this.search()
      }
    },
    //根据code查询标签
    async getCode(code) {
      const res = await codeType({ code: code })
      if (res.data.resultCode == 200) {
        const newCodeData = res.data.data.map((item) => {
          return item.codeName
        })
        if (code == '021') {
          const { data: req } = await selectProjectCenterNumber(newCodeData)
          const newNumber = req.data.split(',')
          const handleCodeData = newCodeData.map((item, index) => {
            return item + `(${newNumber[index]})`
          })
          this.codeData = handleCodeData
        }
        if (code == '022') {
          const { data: req } = await selectPersonChosenNumber(newCodeData)
          const newNumber = req.data.split(',')
          const handleCodeData = newCodeData.map((item, index) => {
            return item + `(${newNumber[index]})`
          })
          this.candidatesData = handleCodeData
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
.headInform {
  height: 138px;
  background-color: #fff;
  border-radius: 4px;
  display: flex;

  .item_information {
    width: 405px;
    padding: 24px 0px 0px 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .inform {
      .top {
        margin-bottom: 13px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          margin-right: 13px;
        }

        .ranking {
          font-size: 14px;
          color: #999999;
        }
      }

      .demand {
        cursor: pointer;
        font-size: 14px;
        color: #333333;
        overflow: hidden;
        width: 270px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3; //多行在这里修改数字即可
        -webkit-box-orient: vertical;
        position: relative;
        top: 16px;
      }

      .demand:hover {
        width: 300px;
        display: block;
      }

      .demand_box {
        font-size: 14px;
        color: #333333;
        // width: 270px;
        background-color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
      }
    }

    .imgboxTop {
      display: flex;
      align-items: center;
      .imageBox {
        width: 64px;
        height: 64px;
        margin-right: 14px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
      }
      .top {
        margin-bottom: 13px;
        display: flex;
        align-items: center;

        .title {
          font-size: 18px;
          font-weight: 600;
          color: #333333;
          margin-right: 13px;
        }

        .ranking {
          font-size: 14px;
          color: #999999;
        }
      }
    }
  }

  .progress_box {
    flex: 1;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    // padding-right: 114px;

    .progress {
      width: 100%;
      box-sizing: border-box;
      height: 98px;
      background-color: rgba(200, 211, 212, 0.1);
      border-radius: 5px;
      display: flex;
      align-items: center;

      /deep/.el-steps--horizontal {
        flex: 1;
      }

      .item {
        color: #17757a;
        font-size: 14px;
      }

      .mapping {
        line-height: 1;
        display: flex;
        align-items: center;
        height: 38px;
        justify-content: center;
      }

      .have_not_started {
        color: #333333;
      }

      .time {
        color: #333333;
      }

      /deep/.el-step__icon-inner {
        display: none;
      }

      /deep/.el-step__icon {
        width: 16px;
        height: 16px;
      }

      /deep/.el-step__line {
        top: 8px;
      }

      // 已完成
      /deep/
        .el-steps.el-steps--horizontal
        .el-step.is-horizontal.is-center
        .el-step__head.is-finish
        .el-step__icon {
        z-index: 1;
        color: #17757a;
        border-color: #17757a;
      }

      // 已完成线
      /deep/
        .el-steps.el-steps--horizontal
        .el-step.is-horizontal.is-center
        .el-step__head.is-finish
        .el-step__line {
        border-color: rgba(23, 117, 122, 0.2);
        background-color: rgba(23, 117, 122, 0.2);
      }
    }
  }

  .back_btn {
    margin: 0 20px 0 20px;
    border: 1px solid #17757a;
    color: #17757a;
    width: 98px;
    height: 40px;
    border-radius: 4px;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    align-self: center;
  }
}
.conditionSearch {
  margin-top: 12px;
  ::v-deep.el-collapse {
    border-top: none !important;
  }
  ::v-deep.el-collapse-item__header {
    padding: 6px 20px;
  }
  ::v-deep#el-collapse-head-7486:hover {
    border-bottom-color: #ebeef5 !important;
  }

  ::v-deep.el-collapse-item__content {
    padding: 20px;
  }
}
.table {
  margin-top: 12px;
  background-color: #f7faf8;
  border-radius: 4px;
  .search {
    .upload_time:nth-child(1) {
      margin-left: 10px !important;
    }
    padding: 18px 10px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    border-bottom: 1px solid rgba(220, 222, 224, 1);
    .upload_time {
      display: flex;
      align-items: center;
      position: relative;
      margin-left: 32px;
      .san {
        margin-left: 6px;
        margin-right: 24px;
        i {
          display: block;
          font-size: 14px;
          position: absolute;
        }
        i:nth-child(1) {
          top: 0;
        }
        i:nth-child(2) {
          top: 7px;
        }
      }
    }
    .caretTime:hover {
      cursor: pointer;
    }
    .isActiveTime1 {
      color: rgba(23, 117, 122, 1) !important;
    }
    .iconColor {
      color: #c0c4cc !important;
    }
  }
  .re {
    position: relative;
  }
  .tag {
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background: rgba(250, 80, 80, 1);
    display: inline-block;
    position: absolute;
  }
}
.tab {
  height: 52px;
  border-bottom: 1px solid #dcdee0;
  display: flex;
  align-items: center;
  margin-top: 16px;
  background-color: #fff;
  border-radius: 4px;

  .tabItem {
    padding: 0 20px;
    cursor: pointer;
    color: #333333;
  }

  .highlight {
    font-weight: 600;
    color: #17757a !important;
  }
}
.input_new {
  margin-right: 20px;
  width: 360px;
  display: flex;
  align-items: center;
  /deep/ .el-button {
    border-radius: 0 4px 4px 0;
    height: 40px;
  }

  /deep/ .el-button--default {
    background-color: #17757a;

    i {
      color: #fff;
    }
  }
}
.labelStyle {
  .project_type {
    display: flex;
    max-height: 40px;

    .type_item {
      padding: 0px 10px;
      cursor: pointer;
      color: #333333;
      height: 32px;
      line-height: 32px;
      margin-right: 10px;
    }
  }

  .pitch {
    border: 1px solid #17757a;
    border-radius: 4px;
    color: #17757a !important;
  }
}
.buttonContent {
  display: flex;
}
.positionType {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 18px;

  .label {
    margin-bottom: 10px;
    color: #333333;
    font-size: 14px;
  }

  .positionType_item {
    line-height: 20px;
    padding: 3px 10px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    margin-bottom: 10px;
    margin-right: 15px;
    box-sizing: border-box;
  }

  .active {
    border: 1px solid #17757a;
    color: #17757a;
    border-radius: 4px;
    font-size: 14px;
  }
}
.spot {
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  .label {
    color: #333333;
    font-size: 14px;
  }
}
.experience {
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  .label {
    color: #333333;
    font-size: 14px;
  }

  .experience_item {
    line-height: 20px;
    padding: 3px 10px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    margin-right: 15px;
    box-sizing: border-box;
  }

  .active {
    border: 1px solid #17757a;
    color: #17757a;
    border-radius: 4px;
    font-size: 14px;
  }
}
.experience {
  ::v-deep.el-radio-button__inner {
    font-size: 14px !important;
  }
}
.experience1 {
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  .label {
    color: #333333;
    font-size: 14px;
  }

  .experience_item {
    line-height: 20px;
    padding: 3px 10px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    margin-right: 15px;
    box-sizing: border-box;
  }

  .active {
    border: 1px solid #17757a;
    border-radius: 4px;
    color: #17757a;
    font-size: 14px;
  }
}
.experience1 {
  ::v-deep.el-radio-button__inner {
    font-size: 14px !important;
  }
}
.el-radio-group ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #17757a;
  background-color: #fff;
  border: #17757a 1px solid;
  box-shadow: none;
  border-radius: 4px;
}

.el-radio-group ::v-deep .el-radio-button--small .el-radio-button__inner {
  padding: 3px 10px;
  font-size: 15px;
  line-height: 20px;
  color: #333;
}
.candidate_list {
  height: calc(100vh - 442px);
  overflow: auto;

  .active {
    border: 1px solid #17757a;
  }

  .candidate_list_item {
    position: relative;
    // width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 110px;
    background-color: #fff;
    padding-left: 11px;
    margin-bottom: 15px;
    .identification {
      position: absolute;
      top: 5px;
      left: 0;
    }

    .left,
    .center,
    .right {
      display: flex;
      align-items: flex-end;
    }

    .left {
      width: 30%;

      .image_box {
        margin-right: 11px;
        width: 72px;
        height: 74px;

        .img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
      }

      .user_info {
        .user_name {
          display: flex;

          .name {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
          }
        }
        .xueli {
          display: flex;
          align-items: center;
          padding: 2px 4px;
          border-radius: 4px;
          color: #17757a;
          border: 1px solid rgba(23, 117, 122, 0.2);
        }
      }

      .age {
        font-size: 12px;
        color: #333333;
        margin-top: 9px;
      }

      .source {
        display: flex;
        align-items: center;
        color: #666666;
        font-size: 14px;
        margin-top: 4px;

        .source_line {
          width: 1px;
          height: 11px;
          background-color: #b2b2b2;
          margin: 0 8px 0 6px;
        }
      }
    }

    .center {
      flex: 1;
      justify-content: flex-start;

      .timeline_box {
        // margin-left: 100px;
        display: flex;
        flex-direction: column;
        //align-items: center;

        /deep/ .el-timeline {
          display: flex;
          flex-direction: column;

          .el-timeline-item {
            padding: 20px 0 0 0;
          }
        }
      }

      /deep/.el-timeline-item {
        padding: 0 !important;
      }

      /deep/ .el-timeline-item__node {
        border: 3px solid #17757a;
        box-sizing: border-box;
        background-color: #fff;
      }

      /deep/ .el-timeline-item__tail {
        border-left: 2px solid #17757a;
      }
    }

    .right {
      width: 30%;
      height: 100%;
      flex-flow: column;
      justify-content: space-evenly;
      padding-right: 76px;

      .right_options {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .shenhe {
          width: 88px;
          height: 32px;
          background: rgba(77, 146, 250, 1);
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          border: none;
          margin-right: 0;
        }

        .newsets {
          width: 89px;
          height: 32px;
          border-radius: 4px;
          border: 1px solid rgba(220, 222, 224, 1);
          background: rgba(220, 222, 224, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          color: rgba(153, 153, 153, 1);
        }
        .newsets:hover {
          border: none !important;
        }

        .compile {
          border: 1px solid #17757a;
          border-radius: 4px;
          width: 84px;
          height: 32px;
          color: #17757a;
          font-size: 14px;
          padding: 6px 7px;
          margin-right: 14px;
          box-sizing: border-box;
          text-align: center;
          cursor: pointer;
        }

        .newest {
          border: 1px solid #17757a;
          border-radius: 4px;
          width: 84px;
          height: 32px;
          color: #17757a;
          font-size: 14px;
          padding: 6px 7px;
          margin-right: 14px;
          box-sizing: border-box;
          text-align: center;
          cursor: pointer;
        }

        .details {
          font-size: 14px;
          color: #17757a;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        ::v-deep.el-button--primary {
          width: 89px;
          height: 32px;
          border: 1px solid rgba(23, 117, 122, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          background: #fff !important;
          color: rgba(23, 117, 122, 1) !important;
          margin-right: 14px;
        }
      }

      .created_time {
        color: #999999;
        font-size: 12px;
        display: flex;
        flex-direction: row-reverse;
      }
    }
  }
}
.reviewReason {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 19.6px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: rgba(255, 169, 89, 1);
  width: 100%;
  img {
    width: 19px;
    height: 19px;
    margin-right: 4px;
    // padding-left: 58%;
  }
}
.pagination {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}
.dialog_box {
  ::v-deep .el-dialog__body {
    padding: 0 80px 30px 80px;
  }

  .title {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .title_name {
      font-size: 18px;

      font-weight: 600;
      color: #333;
    }

    .add {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 99;
      margin-right: 90px;
      width: 80px;
      height: 36px;
      background-color: #17757a;
      border-radius: 4px;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      cursor: pointer;
    }
  }

  ul {
    width: 100%;

    li {
      width: 100%;
      position: relative;
      border-left: 1px dotted #c4c4c4;
      padding: 0 0 14px 14px;
      box-sizing: border-box;

      .circles_box {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #fff;
        border: #1cce66 solid 4px;
        box-sizing: border-box;
        position: absolute;
        top: 4px;
        left: -10px;
        z-index: 9;
      }

      .name_row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 6px;

        .left,
        .right {
          display: flex;
          align-items: center;
        }

        .left {
          .name {
            font-size: 20px;
            font-weight: 550;
            line-height: 28px;
            color: #1a1f33;
          }

          .tag_box {
            width: 80px;
            height: 28px;
            border-radius: 14px;
            font-size: 14px;
            line-height: 28px;
            text-align: center;
            color: #fff;
            background-color: #c4c4c4;
          }

          .yello {
            background-color: rgba(255, 203, 18, 1);
          }

          .tuijian {
            background-color: rgba(28, 206, 102, 1);
          }

          .chushi {
            background-color: rgba(0, 222, 236, 1);
          }

          .fushi {
            background-color: rgba(99, 180, 255, 1);
          }

          .offer {
            background-color: rgba(239, 131, 241, 1);
          }

          .huikuan {
            background-color: rgba(255, 159, 127, 1);
          }
        }

        .right {
          font-size: 14px;
          line-height: 20px;
          color: #999;
          padding-right: 28px;
        }
      }

      .details_row {
        display: flex;
        align-items: center;
        width: 100%;

        .details_box {
          display: flex;
          flex-flow: row wrap;
          width: calc(100% - 28px);
          padding: 10px;
          box-sizing: border-box;
          border: 1px solid #c4c4c4;
          border-radius: 4px;

          .info_item {
            display: flex;
            align-items: center;
            margin-bottom: 8px;

            min-width: 50%;
            font-size: 16px;
            line-height: 24px;

            .item_title {
              text-align: end;
              width: 100px;
              color: #999;
              margin-right: 4px;
            }

            .item_txt {
              display: flex;
              align-items: center;
              color: #1a1f33;
              font-weight: 550;

              i {
                cursor: pointer;
                font-size: 18px;
                color: #f37c25;
              }
            }
          }
        }

        .el-icon-edit-outline {
          cursor: pointer;
          font-size: 16px;
          color: #17757a;
          margin-left: 10px;
        }
      }
    }
  }

  .table_box {
    border-top: 1px solid #e5e5e5;

    .he {
      box-sizing: border-box;
      display: flex;
      color: #333333;
      font-size: 14px;
      font-weight: 600;
      height: 50px;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;

      .stage {
        width: 172px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-right: 1px solid #e5e5e5;
      }

      .rate_of_progress {
        width: 443px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-right: 1px solid #e5e5e5;
      }

      .options_name {
        width: 96px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-right: 1px solid #e5e5e5;
      }

      .newTime {
        width: 238px;
        height: 50px;
        line-height: 50px;
        text-align: center;
      }
    }

    .items {
      box-sizing: border-box;
      display: flex;
      color: #333333;
      font-size: 12px;
      font-weight: 400;
      height: 55px;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;

      div {
        height: 52px;
        line-height: 52px;
      }

      .stage {
        width: 172px;
        text-align: center;
        border-right: 1px solid #e5e5e5;
      }

      .rate_of_progress {
        width: 443px;
        text-align: center;
        border-right: 1px solid #e5e5e5;
      }

      .options_name {
        width: 96px;
        text-align: center;
        border-right: 1px solid #e5e5e5;
      }

      .newTime {
        width: 238px;
        text-align: center;
      }
    }

    .pagination_box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
    }
  }
}
.add_candidate {
  border-radius: 4px;
  border: 1px solid #17757a;
  padding: 8px 5px;
  color: #17757a;
  font-size: 14px;
  cursor: pointer;
  margin-left: 17px;
}
.position_re {
  position: relative;

  .position_ab {
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 99;
    width: fit-content;
    display: flex;
    flex-flow: column;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0px 0px 4px 0px #00000026;
    border-radius: 4px;
    .pad_li {
      padding: 8px 14px;
    }
    li {
      width: 100%;
      white-space: nowrap;
      cursor: pointer;
      font-size: 14px;
      line-height: 24px;
      color: #000;
      // font-weight: 550;
      box-sizing: border-box;
      ::v-deep .el-upload {
        width: 100%;
      }
      ::v-deep .el-button {
        font-size: 14px;
        text-align: left;
        width: 100%;
        padding: 16px 14px 8px 14px;
        border: none;
        color: #000;
      }
    }
    li:hover {
      color: #606266;
      background-color: #f5f7fa;
    }
  }
}
.remove_candidate {
  border-radius: 4px;
  border: 1px solid #17757a;
  padding: 8px 5px;
  color: #17757a;
  font-size: 14px;
  cursor: pointer;
  margin-left: 17px;
}
.addCandidateDialog {
  .head_title {
    display: flex;
    margin-right: 40px;
    .line {
      width: 4px;
      height: 20px;
      border-radius: 4px;
      background-color: #17757a;
      margin-right: 8px;
    }

    .txt {
      color: #333333;
      font-size: 16px;
      font-weight: 600;
    }

    .search_candidate {
      display: flex;
      // 方法一
      margin-left: auto;
      /deep/.el-input {
        width: 289px;
        height: 36px;
      }
      /deep/.el-input__inner {
        width: 289px;
        height: 36px;
      }
      .search_candidate_box {
        width: 48px;
        height: 36px;
        background-color: #17757a;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        cursor: pointer;
      }
    }
  }
  .addCandidateDialog_main {
    margin-top: 26px;
    height: 600px;

    .addCandidateDialog_main_title {
      color: #333333;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
      padding-right: 200px;
      margin-bottom: 14px;

      .addCandidateDialog_main_title_right {
        .select {
          color: #17757a;
          margin-left: 8px;
        }
      }
    }

    .addCandidateDialog_main_box {
      width: 800px;
      height: calc(100% - 140px);
      overflow-y: auto;
      border-top: 1px solid #dcdee0;
      box-sizing: border-box;

      .addCandidateDialog_main_item {
        height: 104px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid#DCDEE0;

        .left {
          display: flex;
          align-items: center;
          .check {
            width: 72px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .img_box {
            width: 72px;
            height: 74px;
            margin-right: 11px;
            .img {
              width: 100%;
              height: 100%;
              border: 4px;
            }
          }
          .info {
            height: 74px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .userName {
              font-size: 18px;
              font-weight: 600;
              color: #333333;
            }
            .shool {
              color: #17757a;
              font-size: 12px;
              font-weight: 400;
              border: 1px solid rgba(23, 117, 122, 0.2);
              padding: 3px 6px;
            }
            .else {
              font-size: 14px;
              color: #666666;
              display: flex;
              align-items: center;

              .else_line {
                width: 1px;
                height: 11px;
                background-color: #b2b2b2;
                margin: 0 8px 0 6px;
              }
            }
          }
        }

        .right {
          display: flex;
          align-items: center;
          .matching_rate {
            display: flex;
            align-items: center;
          }
          .details {
            margin-left: 44px;
            color: #17757a;
            cursor: pointer;
          }
        }
      }
    }
  }
  .pagination_box {
    margin-top: 20px;
  }

  .btn_list {
    display: flex;
    justify-content: center;
    font-size: 12px;
    margin-top: 20px;
    .add {
      border-radius: 4px;
      width: 64px;
      height: 33px;
      background-color: #17757a;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #fff;
    }
    .cancel {
      border-radius: 4px;
      border: 1px solid #17757a;
      width: 64px;
      height: 33px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #17757a;
      margin-left: 34px;
    }
  }
}
/deep/ .add_project_dialog .el-form-item__content {
  margin-bottom: 10px;
}
/deep/ .el-radio-button__inner {
  border: 1px solid #fff !important;
  padding: 6px 10px;
}
/deep/ .el-radio-button__inner:hover {
  color: #17757a;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #fff;
  color: #17757a;
  border: 1px solid #17757a !important;
  box-shadow: none;
}
/deep/ .el-radio-button.is-checked .el-radio-button__inner {
  box-shadow: none;
}

.download {
  border: 1px solid #17757a;
  border-radius: 4px;
  width: 92px;
  height: 32px;
  color: #17757a;
  font-size: 14px;
  padding: 6px 7px;
  margin-right: 14px;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  margin-left: 14px;
}
</style>
